/* eslint-disable */
export default function($pgettext, mapReady)
{
  var g = this;
  var p = window;

  function q(a)
  {
    return void 0 !== a
  }

  function aa(a)
  {
    var b = typeof a;
    if ("object" == b)
      if (a)
      {
        if (a instanceof Array) return "array";
        if (a instanceof Object) return b;
        var c = Object.prototype.toString.call(a);
        if ("[object Window]" == c) return "object";
        if ("[object Array]" == c || "number" == typeof a.length && "undefined" != typeof a.splice && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("splice")) return "array";
        if ("[object Function]" == c || "undefined" != typeof a.call && "undefined" != typeof a.propertyIsEnumerable && !a.propertyIsEnumerable("call")) return "function"
      }
    else return "null";
    else if ("function" == b && "undefined" == typeof a.call) return "object";
    return b
  }

  function ba(a)
  {
    return "array" == aa(a)
  }

  function ca(a)
  {
    var b = aa(a);
    return "array" == b || "object" == b && "number" == typeof a.length
  }

  function t(a)
  {
    return "string" == typeof a
  }

  function da(a)
  {
    var b = typeof a;
    return "object" == b && null != a || "function" == b
  }
  var ea = "closure_uid_" + (1E9 * Math.random() >>> 0),
    fa = 0;

  function ga(a, b, c)
  {
    return a.call.apply(a.bind, arguments)
  }

  function ha(a, b, c)
  {
    if (!a) throw Error();
    if (2 < arguments.length)
    {
      var d = Array.prototype.slice.call(arguments, 2);
      return function()
      {
        var c = Array.prototype.slice.call(arguments);
        Array.prototype.unshift.apply(c, d);
        return a.apply(b, c)
      }
    }
    return function()
    {
      return a.apply(b, arguments)
    }
  }

  function u(a, b, c)
  {
    u = Function.prototype.bind && -1 != Function.prototype.bind.toString().indexOf("native code") ? ga : ha;
    return u.apply(null, arguments)
  }

  function v(a, b)
  {
    var c = Array.prototype.slice.call(arguments, 1);
    return function()
    {
      var b = c.slice();
      b.push.apply(b, arguments);
      return a.apply(this, b)
    }
  }
  var ia = Date.now || function()
  {
    return +new Date
  };

  function w(a, b)
  {
    function c()
    {}
    c.prototype = b.prototype;
    a.A = b.prototype;
    a.prototype = new c;
    a.prototype.constructor = a;
    a.sc = function(a, c, f)
    {
      for (var h = Array(arguments.length - 2), k = 2; k < arguments.length; k++) h[k - 2] = arguments[k];
      return b.prototype[c].apply(a, h)
    }
  };
  var ja;
  var ka = String.prototype.trim ? function(a)
  {
    return a.trim()
  } : function(a)
  {
    return a.replace(/^[\s\xa0]+|[\s\xa0]+$/g, "")
  };

  function la(a)
  {
    if (!ma.test(a)) return a; - 1 != a.indexOf("\x26") && (a = a.replace(na, "\x26amp;")); - 1 != a.indexOf("\x3c") && (a = a.replace(oa, "\x26lt;")); - 1 != a.indexOf("\x3e") && (a = a.replace(pa, "\x26gt;")); - 1 != a.indexOf('"') && (a = a.replace(qa, "\x26quot;")); - 1 != a.indexOf("'") && (a = a.replace(ra, "\x26#39;")); - 1 != a.indexOf("\x00") && (a = a.replace(sa, "\x26#0;"));
    return a
  }
  var na = /&/g,
    oa = /</g,
    pa = />/g,
    qa = /"/g,
    ra = /'/g,
    sa = /\x00/g,
    ma = /[\x00&<>"']/,
    ta = String.prototype.repeat ? function(a, b)
    {
      return a.repeat(b)
    } : function(a, b)
    {
      return Array(b + 1).join(a)
    };

  function ua(a, b, c)
  {
    a = q(c) ? a.toFixed(c) : String(a);
    c = a.indexOf("."); - 1 == c && (c = a.length);
    return ta("0", Math.max(0, b - c)) + a
  }

  function va(a, b)
  {
    return a < b ? -1 : a > b ? 1 : 0
  }

  function wa(a)
  {
    return String(a).replace(/\-([a-z])/g, function(a, c)
    {
      return c.toUpperCase()
    })
  }

  function xa(a)
  {
    var b = t(void 0) ? "undefined".replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, "\\$1").replace(/\x08/g, "\\x08") : "\\s";
    return a.replace(new RegExp("(^" + (b ? "|[" + b + "]+" : "") + ")([a-z])", "g"), function(a, b, e)
    {
      return b + e.toUpperCase()
    })
  };
  var ya = Array.prototype.indexOf ? function(a, b, c)
    {
      return Array.prototype.indexOf.call(a, b, c)
    } : function(a, b, c)
    {
      c = null == c ? 0 : 0 > c ? Math.max(0, a.length + c) : c;
      if (t(a)) return t(b) && 1 == b.length ? a.indexOf(b, c) : -1;
      for (; c < a.length; c++)
        if (c in a && a[c] === b) return c;
      return -1
    },
    x = Array.prototype.forEach ? function(a, b, c)
    {
      Array.prototype.forEach.call(a, b, c)
    } : function(a, b, c)
    {
      for (var d = a.length, e = t(a) ? a.split("") : a, f = 0; f < d; f++) f in e && b.call(c, e[f], f, a)
    },
    za = Array.prototype.filter ? function(a, b, c)
    {
      return Array.prototype.filter.call(a,
        b, c)
    } : function(a, b, c)
    {
      for (var d = a.length, e = [], f = 0, h = t(a) ? a.split("") : a, k = 0; k < d; k++)
        if (k in h)
        {
          var l = h[k];
          b.call(c, l, k, a) && (e[f++] = l)
        } return e
    },
    z = Array.prototype.map ? function(a, b, c)
    {
      return Array.prototype.map.call(a, b, c)
    } : function(a, b, c)
    {
      for (var d = a.length, e = Array(d), f = t(a) ? a.split("") : a, h = 0; h < d; h++) h in f && (e[h] = b.call(c, f[h], h, a));
      return e
    },
    Aa = Array.prototype.reduce ? function(a, b, c, d)
    {
      d && (b = u(b, d));
      return Array.prototype.reduce.call(a, b, c)
    } : function(a, b, c, d)
    {
      var e = c;
      x(a, function(c, h)
      {
        e = b.call(d, e,
          c, h, a)
      });
      return e
    };

  function Ba(a, b)
  {
    return 0 <= ya(a, b)
  }

  function Ca(a, b)
  {
    var c = ya(a, b),
      d;
    (d = 0 <= c) && Array.prototype.splice.call(a, c, 1);
    return d
  }

  function Da(a)
  {
    return Array.prototype.concat.apply(Array.prototype, arguments)
  }

  function Ea(a)
  {
    var b = a.length;
    if (0 < b)
    {
      for (var c = Array(b), d = 0; d < b; d++) c[d] = a[d];
      return c
    }
    return []
  }

  function Fa(a, b, c, d)
  {
    return Array.prototype.splice.apply(a, Ga(arguments, 1))
  }

  function Ga(a, b, c)
  {
    return 2 >= arguments.length ? Array.prototype.slice.call(a, b) : Array.prototype.slice.call(a, b, c)
  }

  function Ha(a, b)
  {
    a.sort(b || Ia)
  }

  function Ia(a, b)
  {
    return a > b ? 1 : a < b ? -1 : 0
  }

  function Ja(a)
  {
    for (var b = [], c = 0; c < a; c++) b[c] = "";
    return b
  };

  function Ka(a, b, c)
  {
    for (var d in a) b.call(c, a[d], d, a)
  }

  function La(a)
  {
    var b = Ma;
    return null !== b && a in b
  }

  function A(a, b, c)
  {
    b in a || (a[b] = c)
  }
  var Na = "constructor hasOwnProperty isPrototypeOf propertyIsEnumerable toLocaleString toString valueOf".split(" ");

  function Oa(a, b)
  {
    for (var c, d, e = 1; e < arguments.length; e++)
    {
      d = arguments[e];
      for (c in d) a[c] = d[c];
      for (var f = 0; f < Na.length; f++) c = Na[f], Object.prototype.hasOwnProperty.call(d, c) && (a[c] = d[c])
    }
  };

  function Pa()
  {
    return function()
    {
      return 1
    }
  };

  function Qa(a, b)
  {
    var c = a % b;
    return 0 > c * b ? c + b : c
  };

  function Ra(a, b)
  {
    this.b = {};
    this.a = [];
    this.g = this.c = 0;
    var c = arguments.length;
    if (1 < c)
    {
      if (c % 2) throw Error("Uneven number of arguments");
      for (var d = 0; d < c; d += 2) this.da(arguments[d], arguments[d + 1])
    }
    else if (a)
    {
      var e;
      if (a instanceof Ra) e = a.na(), d = a.ha();
      else
      {
        var c = [],
          f = 0;
        for (e in a) c[f++] = e;
        e = c;
        c = [];
        f = 0;
        for (d in a) c[f++] = a[d];
        d = c
      }
      for (c = 0; c < e.length; c++) this.da(e[c], d[c])
    }
  }
  g = Ra.prototype;
  g.ha = function()
  {
    Sa(this);
    for (var a = [], b = 0; b < this.a.length; b++) a.push(this.b[this.a[b]]);
    return a
  };
  g.na = function()
  {
    Sa(this);
    return this.a.concat()
  };
  g.isEmpty = function()
  {
    return 0 == this.c
  };
  g.clear = function()
  {
    this.b = {};
    this.g = this.c = this.a.length = 0
  };

  function Sa(a)
  {
    if (a.c != a.a.length)
    {
      for (var b = 0, c = 0; b < a.a.length;)
      {
        var d = a.a[b];
        Ta(a.b, d) && (a.a[c++] = d);
        b++
      }
      a.a.length = c
    }
    if (a.c != a.a.length)
    {
      for (var e = {}, c = b = 0; b < a.a.length;) d = a.a[b], Ta(e, d) || (a.a[c++] = d, e[d] = 1), b++;
      a.a.length = c
    }
  }

  function Ua(a, b)
  {
    return Ta(a.b, b) ? a.b[b] : void 0
  }
  g.da = function(a, b)
  {
    Ta(this.b, a) || (this.c++, this.a.push(a), this.g++);
    this.b[a] = b
  };
  g.forEach = function(a, b)
  {
    for (var c = this.na(), d = 0; d < c.length; d++)
    {
      var e = c[d];
      a.call(b, Ua(this, e), e, this)
    }
  };
  g.clone = function()
  {
    return new Ra(this)
  };

  function Ta(a, b)
  {
    return Object.prototype.hasOwnProperty.call(a, b)
  };
  var Va = /^(?:([^:/?#.]+):)?(?:\/\/(?:([^/?#]*)@)?([^/#?]*?)(?::([0-9]+))?(?=[/#?]|$))?([^?#]+)?(?:\?([^#]*))?(?:#(.*))?$/;

  function Wa(a, b)
  {
    if (a)
      for (var c = a.split("\x26"), d = 0; d < c.length; d++)
      {
        var e = c[d].indexOf("\x3d"),
          f = null,
          h = null;
        0 <= e ? (f = c[d].substring(0, e), h = c[d].substring(e + 1)) : f = c[d];
        b(f, h ? decodeURIComponent(h.replace(/\+/g, " ")) : "")
      }
  };

  function B(a, b)
  {
    this.g = this.m = this.c = "";
    this.j = null;
    this.h = this.o = "";
    this.a = this.v = !1;
    var c;
    if (a instanceof B) this.a = q(b) ? b : a.a, Xa(this, a.c), c = a.m, Ya(this), this.m = c, c = a.g, Ya(this), this.g = c, Za(this, a.j), this.setPath(a.getPath()), $a(this, a.b.clone()), c = a.h, Ya(this), this.h = c;
    else if (a && (c = String(a).match(Va)))
    {
      this.a = !!b;
      Xa(this, c[1] || "", !0);
      var d = c[2] || "";
      Ya(this);
      this.m = ab(d);
      d = c[3] || "";
      Ya(this);
      this.g = ab(d, !0);
      Za(this, c[4]);
      this.setPath(c[5] || "", !0);
      $a(this, c[6] || "", !0);
      c = c[7] || "";
      Ya(this);
      this.h =
        ab(c)
    }
    else this.a = !!b, this.b = new bb(null, 0, this.a)
  }
  B.prototype.toString = function()
  {
    var a = [],
      b = this.c;
    b && a.push(cb(b, db, !0), ":");
    var c = this.g;
    if (c || "file" == b) a.push("//"), (b = this.m) && a.push(cb(b, db, !0), "@"), a.push(encodeURIComponent(String(c)).replace(/%25([0-9a-fA-F]{2})/g, "%$1")), c = this.j, null != c && a.push(":", String(c));
    if (c = this.getPath()) this.g && "/" != c.charAt(0) && a.push("/"), a.push(cb(c, "/" == c.charAt(0) ? eb : fb, !0));
    (c = this.b.toString()) && a.push("?", c);
    (c = this.h) && a.push("#", cb(c, gb));
    return a.join("")
  };
  B.prototype.clone = function()
  {
    return new B(this)
  };

  function Xa(a, b, c)
  {
    Ya(a);
    a.c = c ? ab(b, !0) : b;
    a.c && (a.c = a.c.replace(/:$/, ""))
  }

  function Za(a, b)
  {
    Ya(a);
    if (b)
    {
      b = Number(b);
      if (isNaN(b) || 0 > b) throw Error("Bad port number " + b);
      a.j = b
    }
    else a.j = null
  }
  B.prototype.getPath = function()
  {
    return this.o
  };
  B.prototype.setPath = function(a, b)
  {
    Ya(this);
    this.o = b ? ab(a, !0) : a;
    return this
  };

  function $a(a, b, c)
  {
    Ya(a);
    b instanceof bb ? (a.b = b, hb(a.b, a.a)) : (c || (b = cb(b, ib)), a.b = new bb(b, 0, a.a))
  }

  function Ya(a)
  {
    if (a.v) throw Error("Tried to modify a read-only Uri");
  }

  function ab(a, b)
  {
    return a ? b ? decodeURI(a.replace(/%25/g, "%2525")) : decodeURIComponent(a) : ""
  }

  function cb(a, b, c)
  {
    return t(a) ? (a = encodeURI(a).replace(b, jb), c && (a = a.replace(/%25([0-9a-fA-F]{2})/g, "%$1")), a) : null
  }

  function jb(a)
  {
    a = a.charCodeAt(0);
    return "%" + (a >> 4 & 15).toString(16) + (a & 15).toString(16)
  }
  var db = /[#\/\?@]/g,
    fb = /[\#\?:]/g,
    eb = /[\#\?]/g,
    ib = /[\#\?@]/g,
    gb = /#/g;

  function bb(a, b, c)
  {
    this.b = this.a = null;
    this.c = a || null;
    this.g = !!c
  }

  function kb(a)
  {
    a.a || (a.a = new Ra, a.b = 0, a.c && Wa(a.c, function(b, c)
    {
      var d = decodeURIComponent(b.replace(/\+/g, " "));
      kb(a);
      a.c = null;
      var d = lb(a, d),
        e = Ua(a.a, d);
      e || a.a.da(d, e = []);
      e.push(c);
      a.b = a.b + 1
    }))
  }

  function mb(a, b)
  {
    kb(a);
    b = lb(a, b);
    if (Ta(a.a.b, b))
    {
      a.c = null;
      a.b = a.b - Ua(a.a, b).length;
      var c = a.a;
      Ta(c.b, b) && (delete c.b[b], c.c--, c.g++, c.a.length > 2 * c.c && Sa(c))
    }
  }
  g = bb.prototype;
  g.clear = function()
  {
    this.a = this.c = null;
    this.b = 0
  };
  g.isEmpty = function()
  {
    kb(this);
    return 0 == this.b
  };

  function C(a, b)
  {
    kb(a);
    b = lb(a, b);
    return Ta(a.a.b, b)
  }
  g.na = function()
  {
    kb(this);
    for (var a = this.a.ha(), b = this.a.na(), c = [], d = 0; d < b.length; d++)
      for (var e = a[d], f = 0; f < e.length; f++) c.push(b[d]);
    return c
  };
  g.ha = function(a)
  {
    kb(this);
    var b = [];
    if (t(a)) C(this, a) && (b = Da(b, Ua(this.a, lb(this, a))));
    else
    {
      a = this.a.ha();
      for (var c = 0; c < a.length; c++) b = Da(b, a[c])
    }
    return b
  };

  function D(a, b, c)
  {
    kb(a);
    a.c = null;
    b = lb(a, b);
    C(a, b) && (a.b = a.b - Ua(a.a, b).length);
    a.a.da(b, [c]);
    a.b = a.b + 1
  }

  function nb(a, b)
  {
    var c = b ? a.ha(b) : [];
    return 0 < c.length ? String(c[0]) : void 0
  }
  g.toString = function()
  {
    if (this.c) return this.c;
    if (!this.a) return "";
    for (var a = [], b = this.a.na(), c = 0; c < b.length; c++)
      for (var d = b[c], e = encodeURIComponent(String(d)), d = this.ha(d), f = 0; f < d.length; f++)
      {
        var h = e;
        "" !== d[f] && (h += "\x3d" + encodeURIComponent(String(d[f])));
        a.push(h)
      }
    return this.c = a.join("\x26")
  };
  g.clone = function()
  {
    var a = new bb;
    a.c = this.c;
    this.a && (a.a = this.a.clone(), a.b = this.b);
    return a
  };

  function lb(a, b)
  {
    var c = String(b);
    a.g && (c = c.toLowerCase());
    return c
  }

  function hb(a, b)
  {
    b && !a.g && (kb(a), a.c = null, a.a.forEach(function(a, b)
    {
      var e = b.toLowerCase();
      b != e && (mb(this, b), mb(this, e), 0 < a.length && (this.c = null, this.a.da(lb(this, e), Ea(a)), this.b = this.b + a.length))
    }, a));
    a.g = b
  };

  function ob(a)
  {
    this.a = a
  }
  var pb = /\s*;\s*/;

  function qb(a, b, c, d, e, f)
  {
    if (/[;=\s]/.test(b)) throw Error('Invalid cookie name "' + b + '"');
    if (/[;\r\n]/.test(c)) throw Error('Invalid cookie value "' + c + '"');
    q(d) || (d = -1);
    f = f ? ";domain\x3d" + f : "";
    e = e ? ";path\x3d" + e : "";
    d = 0 > d ? "" : 0 == d ? ";expires\x3d" + (new Date(1970, 1, 1)).toUTCString() : ";expires\x3d" + (new Date(ia() + 1E3 * d)).toUTCString();
    a.a.cookie = b + "\x3d" + c + f + e + d + ""
  }

  function rb(a)
  {
    for (var b = a + "\x3d", c = (sb.a.cookie || "").split(pb), d = 0, e; e = c[d]; d++)
    {
      if (0 == e.lastIndexOf(b, 0)) return e.substr(b.length);
      if (e == a) return ""
    }
  }
  ob.prototype.na = function()
  {
    return tb(this).keys
  };
  ob.prototype.ha = function()
  {
    return tb(this).values
  };
  ob.prototype.isEmpty = function()
  {
    return !this.a.cookie
  };
  ob.prototype.clear = function()
  {
    for (var a = tb(this).keys, b = a.length - 1; 0 <= b; b--) qb(this, a[b], "", 0, void 0, void 0)
  };

  function tb(a)
  {
    a = (a.a.cookie || "").split(pb);
    for (var b = [], c = [], d, e, f = 0; e = a[f]; f++) d = e.indexOf("\x3d"), -1 == d ? (b.push(""), c.push(e)) : (b.push(e.substring(0, d)), c.push(e.substring(d + 1)));
    return {
      keys: b,
      values: c
    }
  }
  var sb = new ob(document);
  sb.b = 3950;
  new google.maps.Size(256, 256);
  new google.maps.Size(256, 256);
  var wb = {
    alt: "XContest",
    getTileUrl: function(a, b)
    {
      return "http://maps.pgweb.cz/elev/" + b + "/" + a.x + "/" + a.y
    },
    maxZoom: 16,
    minZoom: 0,
    name: "XContest",
    tileSize: new google.maps.Size(256, 256)
  };
  function EmptyMap () {
    this.tileSize = new google.maps.Size(256, 256);
    this.name = "empty";
    this.alt = "empty";
    this.maxZoom = 19;
    this.getTile = function () { return "" };
  };

  function xb(a, b)
  {
    var c = Array.prototype.slice.call(arguments),
      d = c.shift();
    if ("undefined" == typeof d) throw Error("[goog.string.format] Template required");
    return d.replace(/%([0\-\ \+]*)(\d+)?(\.(\d+))?([%sfdiu])/g, function(a, b, d, k, l, n, m, r)
    {
      if ("%" == n) return "%";
      var y = c.shift();
      if ("undefined" == typeof y) throw Error("[goog.string.format] Not enough arguments");
      arguments[0] = y;
      return yb[n].apply(null, arguments)
    })
  }
  var yb = {
    s: function(a, b, c)
    {
      return isNaN(c) || "" == c || a.length >= Number(c) ? a : a = -1 < b.indexOf("-", 0) ? a + ta(" ", Number(c) - a.length) : ta(" ", Number(c) - a.length) + a
    },
    f: function(a, b, c, d, e)
    {
      d = a.toString();
      isNaN(e) || "" == e || (d = parseFloat(a).toFixed(e));
      var f;
      f = 0 > Number(a) ? "-" : 0 <= b.indexOf("+") ? "+" : 0 <= b.indexOf(" ") ? " " : "";
      0 <= Number(a) && (d = f + d);
      if (isNaN(c) || d.length >= Number(c)) return d;
      d = isNaN(e) ? Math.abs(a).toString() : Math.abs(a).toFixed(e);
      a = Number(c) - d.length - f.length;
      return d = 0 <= b.indexOf("-", 0) ? f + d + ta(" ", a) :
        f + ta(0 <= b.indexOf("0", 0) ? "0" : " ", a) + d
    },
    d: function(a, b, c, d, e, f, h, k)
    {
      return yb.f(parseInt(a, 10), b, c, d, 0, f, h, k)
    }
  };
  yb.i = yb.d;
  yb.u = yb.d;

  function zb(a, b, c, d)
  {
    return [(d * a).toFixed(b), c]
  }
  var Ab = v(zb, 1 / .3048, 0, "\u2032"),
    Bb = v(zb, .001, 1, "km"),
    Cb = v(zb, 3.6, 1, "km/h"),
    Db = v(zb, 1, 0, "m"),
    Eb = v(zb, 1 / 1609.344, 1, "miles"),
    Fb = v(zb, 3600 / 1609.344, 1, "mph");

  function Gb(a, b)
  {
    var c = Math.abs(Math.round(6E4 * a));
    return [
      [Math.floor(c / 6E4), "\u00b0"],
      [(c % 6E4 / 1E3).toFixed(3), "\u2032"],
      [b.charAt(0 > a ? 1 : 0), ""]
    ]
  }

  function Hb(a, b)
  {
    var c = Math.abs(60 * a);
    return [
      [xb("%s%d:%05.3f", b.charAt(0 > a ? 1 : 0), Math.floor(c / 60), c % 60), ""]
    ]
  }
  var Ib = [Db, Ab],
    Jb = ["meters", "feet"],
    Kb = [function(a, b)
    {
      return [
        [Math.abs(a).toFixed(5), "\u00b0"],
        [b.charAt(0 > a ? 1 : 0), ""]
      ]
    }, Gb, function(a, b)
    {
      var c = Math.abs(Math.round(3600 * a));
      return [
        [Math.floor(c / 3600), "\u00b0"],
        [Math.floor(c / 60 % 60), "\u2032"],
        [Math.floor(c % 60), "\u2033"],
        [b.charAt(0 > a ? 1 : 0), ""]
      ]
    }, Hb, function(a, b)
    {
      var c = Math.abs(3600 * a);
      return [
        [xb("%s%d:%02d:%05.2f", b.charAt(0 > a ? 1 : 0), Math.floor(c / 3600), Math.floor(c / 60 % 60), c % 60), ""]
      ]
    }],
    Lb = ["ddd.ddddd\u00b0", "ddd\u00b0 mm.mmm\u2032", "ddd\u00b0 mm\u2032 ss\u2033",
      "dd:mm.mmm", "dd:mm:ss.ss"
    ],
    Mb = [Bb, Eb],
    Nb = ["kilometres", "miles"];

  function Ob(a, b)
  {
    this.a = a;
    this.b = b
  };

  function Pb(a)
  {
    var b, c;
    this.a = a.length;
    this.g = Array(this.a * (this.a - 1) / 2);
    var d = 0;
    for (c = 1; c < this.a; ++c)
      for (b = 0; b < c; ++b) this.g[d++] = google.maps.geometry.spherical.computeDistanceBetween(a[b], a[c], 6371E3);
    this.j = Array(this.a - 1);
    for (b = 0; b < this.a - 1; ++b) this.j[b] = Qb(this, b, b + 1);
    this.h = Math.max.apply(null, this.j);
    this.b = this.c = null
  }

  function Rb(a)
  {
    var b;
    if (null === a.c)
    {
      var c = Array(2 * a.a);
      c[0] = 0;
      c[1] = 0;
      for (b = 1; b < a.a; ++b) Sb(a, b, 0, b, c[2 * (b - 1)], c[2 * (b - 1) + 1] - a.h, c, 2 * b);
      a.c = c
    }
    if (null === a.b)
    {
      c = Array(2 * a.a);
      Sb(a, 0, 1, a.a, a.a - 1, 0, c, 0);
      for (b = 1; b < a.a - 1; ++b) Sb(a, b, b + 1, a.a, c[2 * (b - 1)], c[2 * (b - 1) + 1] - a.h, c, 2 * b);
      c[2 * (a.a - 1)] = a.a - 1;
      c[2 * (a.a - 1) + 1] = 0;
      a.b = c
    }
  }

  function Tb(a, b, c)
  {
    a = Math.floor(c / a.h);
    return 0 < a ? b + a : b + 1
  }

  function Ub(a, b, c)
  {
    return b < c ? a.g[b + c * (c - 1) / 2] : b == c ? 0 : a.g[b * (b - 1) / 2 + c]
  }

  function Sb(a, b, c, d, e, f, h, k)
  {
    var l;
    for (l = c; l < d;) c = Ub(a, b, l), c > f ? (f = c, e = l, ++l) : l = Tb(a, l, f - c);
    h[k] = e;
    h[k + 1] = f
  }

  function Qb(a, b, c)
  {
    return a.g[b + c * (c - 1) / 2]
  };

  function Vb()
  {}
  Vb.prototype.oa = function(a)
  {
    var b = Array(a),
      c;
    for (c = 0; c < a; ++c) b[c] = c + 1 + "";
    return b
  };

  function Wb(a)
  {
    this.distance = a.distance || 0;
    this.ua = a.ua || null;
    this.J = a.J || [];
    this.$ = a.$ || 1;
    this.name = a.name || "";
    this.ia = a.ia || null;
    this.ja = a.ja || 0;
    this.a = this.distance * this.$ / 1E3
  }

  function Xb(a, b, c, d, e, f, h, k, l)
  {
    var n = l[2],
      m = f.length;
    f = k[0] + k[1] + k[2];
    d = c = d ? c : c * f;
    var r = null,
      y, ub, vb;
    for (ub = l[0]; 0 <= ub; --ub)
      for (vb = n; vb < m; ++vb) y = Ub(h, ub, vb), y <= d && (d = y, r = [ub, l[0], l[1], l[2], vb]);
    if (null === r) return null;
    if (q(b) && .28 <= Math.min.apply(null, k) / f) a = b, b = "Yassen triangle", h = 3;
    else if (q(a)) b = "Flat triangle", h = 2;
    else return null;
    return new Wb(
    {
      distance: e ? f - d : f,
      ua: l,
      J: r,
      $: a,
      name: b,
      ia: c,
      ja: h
    })
  }

  function Yb(a, b, c, d, e, f)
  {
    b = b.length;
    if (0 === d || 2 == b)
    {
      b = d = Array(2);
      b[0] = b[1] = -1;
      var h = -Infinity,
        k, l;
      for (l = 0; l < c.a - 1; ++l)
      {
        k = h;
        for (var n = void 0, m = void 0, r = -1, m = l + 1; m < c.a;) n = Ub(c, l, m), n > k ? (k = n, r = m, ++m) : m = Tb(c, m, k - n);
        k = [r, k]; - 1 != k[0] && (b[0] = l, b[1] = k[0], h = k[1])
      }
      c = h
    }
    else if (1 == d || 3 == b)
    {
      b = d = Array(3);
      Rb(c);
      b[0] = b[1] = b[2] = -1;
      h = -Infinity;
      for (k = 1; k < c.a - 1;) l = c.c[2 * k + 1] + c.b[2 * k + 1], l > h ? (b[0] = c.c[2 * k], b[1] = k, b[2] = c.b[2 * k], h = l, ++k) : k = Tb(c, k, (h - l) / 2);
      c = h
    }
    else if (2 == d || 4 == b)
    {
      b = d = Array(4);
      Rb(c);
      b[0] = b[1] = b[2] = b[3] = -1;
      h = -Infinity;
      for (n = 1; n < c.a - 2; ++n)
        for (k = c.c[2 * n + 1], m = n + 1; m < c.a - 1;) l = k + Qb(c, n, m) + c.b[2 * m + 1], l > h ? (h = l, b[0] = c.c[2 * n], b[1] = n, b[2] = m, b[3] = c.b[2 * m], ++m) : m = Tb(c, m, (h - l) / 2);
      c = h
    }
    else if (3 == d || 5 == b)
    {
      b = d = Array(5);
      Rb(c);
      b[0] = b[1] = b[2] = b[3] = b[4] = -1;
      for (var h = -Infinity, y, m = 1; m < c.a - 3; ++m)
        for (k = c.c[2 * m + 1], r = m + 1; r < c.a - 2; ++r)
          for (n = Qb(c, m, r), y = r + 1; y < c.a - 1;) l = k + n + Qb(c, r, y) + c.b[2 * y + 1], l > h ? (h = l, b[0] = c.c[2 * m], b[1] = m, b[2] = r, b[3] = y, b[4] = c.b[2 * y], ++y) : y = Tb(c, y, (h - l) / 2);
      c = h
    }
    else d = [], c = 0;
    a.push(new Wb(
    {
      distance: c,
      J: d,
      $: e(c),
      name: f
    }))
  }

  function Zb(a, b, c, d, e)
  {
    var f = b.length,
      h, k, l, n = Array(3),
      m;
    for (h = 0; h < f - 2; ++h)
      for (k = h + 1; k < f - 1; ++k)
        if (n[0] = Ub(c, h, k), q(d) && (m = d(b, c, n, [h, k]), null === m || a.push(m)), q(e))
          for (l = k + 1; l < f; ++l) n[1] = Ub(c, k, l), n[2] = Ub(c, l, h), m = e(b, c, n, [h, k, l]), null === m || a.push(m)
  };

  function E(a, b, c, d, e, f, h)
  {
    this.c = a;
    this.b = b;
    this.g = v(Xb, c, d, e, f, h)
  }
  w(E, Vb);
  g = E.prototype;
  g.getId = function()
  {
    return this.b
  };
  g.oa = function(a)
  {
    var b, c = Array(a);
    c[0] = "SP";
    for (b = 1; b < a - 1; ++b) c[b] = "TP" + b;
    c[a - 1] = "KB";
    return c
  };
  g.W = function()
  {
    return this.c
  };
  g.rc = function()
  {
    return 1
  };
  g.P = function(a, b)
  {
    var c = [];
    Yb(c, a, b, 3, this.rc, "Open distance");
    Zb(c, a, b, void 0, this.g);
    return c
  };

  function $b()
  {
    E.call(this, "Switzerland (XContest)", "ch", 1.2, 1.3, .2, !1, !0)
  }
  w($b, E);
  $b.prototype.a = function()
  {
    return 1.2
  };
  $b.prototype.P = function(a, b)
  {
    var c = $b.A.P.call(this, a, b);
    Yb(c, a, b, 0, this.a, "Free distance");
    return c
  };

  function ac()
  {
    E.call(this, "XContest", "xcontest", 1.2, 1.4, .2, !1, !0);
    this.a = v(Xb, 1.4, 1.6, .05, !1, !0)
  }
  w(ac, E);
  ac.prototype.P = function(a, b)
  {
    var c = ac.A.P.call(this, a, b);
    Zb(c, a, b, void 0, this.a);
    return c
  };
  var bc = new E("Australia (XContest)", "au", 1.4, 1.8, .2, !1, !0),
    cc = new E("Canada (XContest)", "ca", 1.2, 1.4, .05, !1, !0),
    dc = new $b,
    ec = new E("Chile (XContest)", "cl", 2, 3, .2, !1, !0),
    fc = new E("Czech Republic (XContest)", "cz", 1.8, 2.2, .05, !1, !0),
    gc = new E("Spain (XContest)", "es", 1.5, 2, .2, !1, !0),
    hc = new E("Finland (XContest)", "fi", 1.2, 1.4, .2, !1, !0),
    ic = new E("Hungary (XContest)", "hu", 1.8, 2, 800, !0, !0),
    jc = new E("Lithuania (XContest)", "lt", 1.5, 2, .2, !1, !0),
    kc = new E("Slovakia (XContest)", "sk", 1.8, 2.2, .05, !1, !0),
    lc = new ac;

  function mc()
  {
    this.a = v(Xb, 1.2, 1.4, 3E3, !0, !1);
    this.b = v(Xb, 1.2, 1.4, .05, !1, !0)
  }
  w(mc, Vb);
  g = mc.prototype;
  g.getId = function()
  {
    return "fr"
  };
  g.oa = function(a)
  {
    var b, c = Array(a);
    c[0] = "BD";
    for (b = 1; b < a - 1; ++b) c[b] = "B" + b;
    c[a - 1] = "BA";
    return c
  };
  g.W = function()
  {
    return "France (Coupe F\u00e9d\u00e9rale de Distance)"
  };
  g.oc = function(a)
  {
    return 15E3 > a ? 0 : 1
  };
  g.P = function(a, b)
  {
    var c = [];
    Yb(c, a, b, 2, this.oc, "Distance libre");
    Zb(c, a, b, void 0, this.a);
    Zb(c, a, b, void 0, this.b);
    return c
  };
  var nc = new mc;

  function oc()
  {}
  w(oc, Vb);
  oc.prototype.getId = function()
  {
    return "free"
  };
  oc.prototype.W = function()
  {
    return "Free flight"
  };
  oc.prototype.P = function(a, b)
  {
    var c, d = a.length,
      e = 0;
    for (c = 0; c < d - 1; ++c) e += Qb(b, c, c + 1);
    var f = Array(d);
    for (c = 0; c < d; ++c) f[c] = c;
    return [new Wb(
    {
      distance: e,
      J: f,
      $: 1,
      name: "Free flight"
    })]
  };
  var pc = new oc;

  function qc()
  {
    this.a = v(Xb, 1.75, 2, .2, !1, !0)
  }
  w(qc, Vb);
  qc.prototype.getId = function()
  {
    return "leonardo"
  };
  qc.prototype.W = function()
  {
    return "Leonardo"
  };
  qc.prototype.b = function()
  {
    return 1.5
  };
  qc.prototype.P = function(a, b)
  {
    var c = [];
    Yb(c, a, b, 3, this.b, "Open distance");
    Zb(c, a, b, void 0, this.a);
    return c
  };
  var F = new qc;

  function rc()
  {
    this.a = v(Xb, void 0, 1.6, .08, !1, !0);
    this.b = v(Xb, 1.2, void 0, .2, !1, !0)
  }
  w(rc, Vb);
  g = rc.prototype;
  g.getId = function()
  {
    return "mx"
  };
  g.oa = function(a)
  {
    var b, c = Array(a);
    c[0] = "SP";
    for (b = 1; b < a - 1; ++b) c[b] = "TP" + b;
    c[a - 1] = "KB";
    return c
  };
  g.W = function()
  {
    return "Mexico (XContest)"
  };
  g.pc = function()
  {
    return 1
  };
  g.P = function(a, b)
  {
    var c = [];
    Yb(c, a, b, 3, this.pc, "Open distance");
    Zb(c, a, b, void 0, this.a);
    Zb(c, a, b, void 0, this.b);
    return c
  };
  var sc = new rc;

  function tc()
  {}
  w(tc, Vb);
  tc.prototype.getId = function()
  {
    return "open"
  };
  tc.prototype.W = function()
  {
    return "Open distance"
  };
  tc.prototype.P = function(a, b)
  {
    var c = [];
    Yb(c, a, b, 0, Pa(), "Open distance");
    return c
  };
  var uc = new tc;

  function vc(a, b)
  {
    this.b = a;
    this.a = b;
    this.c = v(Xb, 1.25, 1.5, .2, !1, !0)
  }
  w(vc, Vb);
  g = vc.prototype;
  g.getId = function()
  {
    return this.a
  };
  g.oa = function(a)
  {
    var b, c = Array(a);
    c[0] = "SP";
    for (b = 1; b < a - 1; ++b) c[b] = "TP" + b;
    c[a - 1] = "KB";
    return c
  };
  g.W = function()
  {
    return this.b
  };
  g.qc = function()
  {
    return 1
  };
  g.P = function(a, b)
  {
    var c = [];
    Yb(c, a, b, 3, this.qc, "Open distance");
    Zb(c, a, b, void 0, this.c);
    return c
  };
  var wc = new vc("Poland (XCCompetitions)", "pl");

  function xc(a, b, c)
  {
    var d = null,
      e = -Infinity,
      f = -Infinity;
    b = b.length;
    var h, k, l, n, m, r;
    for (k = 0; k < b - 1; ++k)
      for (l = k; l < b - 1; ++l)
        for (m = l + 1; m < b; ++m)
          for (n = Ub(c, l, m), r = m; r < b; ++r) h = Ub(c, k, r), 800 < h || (h = 2 * n - h, h > f && (d = [k, l, m, r], e = n, f = h));
    return null === d ? null : new Wb(
    {
      distance: f,
      J: d,
      $: a(2 * e),
      name: "Out and return",
      ia: 800,
      ja: 1
    })
  }

  function yc(a, b, c, d, e, f)
  {
    var h = f[0],
      k = f[2],
      l = c.length,
      n = e[0] + e[1] + e[2],
      m = Math.min.apply(null, e) / n;
    if (.28 <= m) b = a(n), e = "Yassen triangle", a = 3;
    else if (.45 >= m)
    {
      a = z([zc(c[f[0]], c[f[1]], c[f[2]]), zc(c[f[1]], c[f[2]], c[f[0]]), zc(c[f[2]], c[f[0]], c[f[1]])], Math.abs);
      if (.15 > Math.min.apply(null, a) / Math.max.apply(null, e)) return null;
      b = b(n);
      e = "Flat triangle";
      a = 2
    }
    else return null;
    c = Infinity;
    var m = null,
      r, y;
    for (r = h; 0 <= r; --r)
      for (y = k; y < l; ++y) h = Ub(d, r, y), h < c && 800 > h && (c = h, m = [r, f[0], f[1], f[2], y]);
    return null === m ? null : new Wb(
    {
      distance: n -
        c,
      ua: f,
      J: m,
      $: b,
      name: e,
      ia: 800,
      ja: a
    })
  }

  function Ac()
  {
    this.a = v(xc, this.Ia);
    this.b = v(yc, this.Qa, this.Ia)
  }
  w(Ac, Vb);
  Ac.prototype.oa = function(a)
  {
    var b, c = Array(a);
    c[0] = "Start";
    for (b = 1; b < a - 1; ++b) c[b] = "TP" + b;
    c[a - 1] = "Finish";
    return c
  };
  Ac.prototype.P = function(a, b)
  {
    var c = [];
    Yb(c, a, b, 3, this.Ta, "Open distance");
    Zb(c, a, b, this.a, this.b);
    return c
  };

  function Bc()
  {
    Ac.call(this)
  }
  w(Bc, Ac);
  g = Bc.prototype;
  g.getId = function()
  {
    return "ukc"
  };
  g.W = function()
  {
    return "United Kingdom (XC League, Club)"
  };
  g.Qa = function(a)
  {
    return 5E3 > a ? 0 : 15E3 > a ? 1.5 : 35E3 > a ? 1.7 : 2
  };
  g.Ia = function(a)
  {
    return 5E3 > a ? 0 : 15E3 > a ? 1.2 : 35E3 > a ? 1.3 : 1.7
  };
  g.Ta = function(a)
  {
    return 5E3 > a ? 0 : 1
  };
  var Cc = new Bc;

  function Dc()
  {
    Ac.call(this)
  }
  w(Dc, Ac);
  g = Dc.prototype;
  g.getId = function()
  {
    return "uki"
  };
  g.W = function()
  {
    return "United Kingdom (XC League, International)"
  };
  g.Qa = function(a)
  {
    return 25E3 > a ? 0 : 1.5
  };
  g.Ia = function(a)
  {
    return 35E3 > a ? 0 : 1.2
  };
  g.Ta = function(a)
  {
    return 1E4 > a ? 0 : 1
  };
  var Ec = new Dc;

  function Fc()
  {
    Ac.call(this)
  }
  w(Fc, Ac);
  g = Fc.prototype;
  g.getId = function()
  {
    return "uk"
  };
  g.W = function()
  {
    return "United Kingdom (XC League, National)"
  };
  g.Qa = function(a)
  {
    return 15E3 > a ? 0 : 25E3 > a ? 1.7 : 2
  };
  g.Ia = function(a)
  {
    return 15E3 > a ? 0 : 35E3 > a ? 1.3 : 1.7
  };
  g.Ta = function(a)
  {
    return 1E4 > a ? 0 : 1
  };
  var Gc = new Fc;
  var Hc = [uc, pc, F, lc, bc, cc, ec, fc, hc, nc, ic, jc, sc, wc, kc, gc, dc, Cc, Gc, Ec];

  function Ic(a, b, c)
  {
    0 > c ? c += 1 : 1 < c && --c;
    return 1 > 6 * c ? a + 6 * (b - a) * c : 1 > 2 * c ? b : 2 > 3 * c ? a + (b - a) * (2 / 3 - c) * 6 : a
  }

  function Jc(a)
  {
    return 1 == a.length ? "0" + a : a
  }

  function Kc(a)
  {
    var b, c = a[1];
    b = a[2];
    var d = 0,
      e = 0,
      f = 0;
    a = a[0] / 360;
    if (0 == c) d = e = f = 255 * b;
    else var h = f = 0,
      h = .5 > b ? b * (1 + c) : b + c - c * b,
      f = 2 * b - h,
      d = 255 * Ic(f, h, a + 1 / 3),
      e = 255 * Ic(f, h, a),
      f = 255 * Ic(f, h, a - 1 / 3);
    b = [Math.round(d), Math.round(e), Math.round(f)];
    d = b[0];
    c = b[1];
    b = b[2];
    d = Number(d);
    c = Number(c);
    b = Number(b);
    if (d != (d & 255) || c != (c & 255) || b != (b & 255)) throw Error('"(' + d + "," + c + "," + b + '") is not a valid RGB color');
    d = Jc(d.toString(16));
    c = Jc(c.toString(16));
    b = Jc(b.toString(16));
    return "#" + d + c + b
  };

  function Lc(a)
  {
    var b = a.type;
    if (!q(b)) return null;
    switch (b.toLowerCase())
    {
      case "checkbox":
      case "radio":
        return a.checked ? a.value : null;
      case "select-one":
        return b = a.selectedIndex, 0 <= b ? a.options[b].value : null;
      case "select-multiple":
        for (var b = [], c, d = 0; c = a.options[d]; d++) c.selected && b.push(c.value);
        return b.length ? b : null;
      default:
        return q(a.value) ? a.value : null
    }
  };
  var Mc;
  a:
  {
    var Nc = p.navigator;
    if (Nc)
    {
      var Oc = Nc.userAgent;
      if (Oc)
      {
        Mc = Oc;
        break a
      }
    }
    Mc = ""
  }

  function G(a)
  {
    return -1 != Mc.indexOf(a)
  };
  var Pc = G("Opera") || G("OPR"),
    H = G("Trident") || G("MSIE"),
    Qc = G("Edge"),
    Rc = G("Gecko") && !(-1 != Mc.toLowerCase().indexOf("webkit") && !G("Edge")) && !(G("Trident") || G("MSIE")) && !G("Edge"),
    Sc = -1 != Mc.toLowerCase().indexOf("webkit") && !G("Edge"),
    Tc = G("Macintosh"),
    Uc = G("Windows"),
    Vc = G("Linux") || G("CrOS");

  function Wc()
  {
    var a = Mc;
    if (Rc) return /rv\:([^\);]+)(\)|;)/.exec(a);
    if (Qc) return /Edge\/([\d\.]+)/.exec(a);
    if (H) return /\b(?:MSIE|rv)[: ]([^\);]+)(\)|;)/.exec(a);
    if (Sc) return /WebKit\/(\S+)/.exec(a)
  }

  function Xc()
  {
    var a = p.document;
    return a ? a.documentMode : void 0
  }
  var Yc = function()
    {
      if (Pc && p.opera)
      {
        var a;
        var b = p.opera.version;
        try
        {
          a = b()
        }
        catch (c)
        {
          a = b
        }
        return a
      }
      a = "";
      (b = Wc()) && (a = b ? b[1] : "");
      return H && (b = Xc(), b > parseFloat(a)) ? String(b) : a
    }(),
    Zc = {};

  function I(a)
  {
    var b;
    if (!(b = Zc[a]))
    {
      b = 0;
      for (var c = ka(String(Yc)).split("."), d = ka(String(a)).split("."), e = Math.max(c.length, d.length), f = 0; 0 == b && f < e; f++)
      {
        var h = c[f] || "",
          k = d[f] || "",
          l = RegExp("(\\d*)(\\D*)", "g"),
          n = RegExp("(\\d*)(\\D*)", "g");
        do {
          var m = l.exec(h) || ["", "", ""],
            r = n.exec(k) || ["", "", ""];
          if (0 == m[0].length && 0 == r[0].length) break;
          b = va(0 == m[1].length ? 0 : parseInt(m[1], 10), 0 == r[1].length ? 0 : parseInt(r[1], 10)) || va(0 == m[2].length, 0 == r[2].length) || va(m[2], r[2])
        } while (0 == b)
      }
      b = Zc[a] = 0 <= b
    }
    return b
  }
  var $c = p.document,
    ad = $c && H ? Xc() || ("CSS1Compat" == $c.compatMode ? parseInt(Yc, 10) : 5) : void 0;
  var bd = !H || 9 <= Number(ad),
    cd = !H || 9 <= Number(ad),
    dd = H && !I("9");
  !Sc || I("528");
  Rc && I("1.9b") || H && I("8") || Pc && I("9.5") || Sc && I("528");
  Rc && !I("8") || H && I("9");

  function ed()
  {
    0 != fd && (gd[this[ea] || (this[ea] = ++fa)] = this);
    this.o = this.o;
    this.m = this.m
  }
  var fd = 0,
    gd = {};
  ed.prototype.o = !1;
  ed.prototype.wa = function()
  {
    return this.o
  };
  ed.prototype.Z = function()
  {
    if (!this.o && (this.o = !0, this.C(), 0 != fd))
    {
      var a = this[ea] || (this[ea] = ++fa);
      delete gd[a]
    }
  };
  ed.prototype.C = function()
  {
    if (this.m)
      for (; this.m.length;) this.m.shift()()
  };

  function hd(a)
  {
    a && "function" == typeof a.Z && a.Z()
  };

  function id(a, b)
  {
    this.type = a;
    this.a = this.target = b;
    this.j = !1;
    this.gb = !0
  }
  id.prototype.h = function()
  {
    this.j = !0
  };
  id.prototype.b = function()
  {
    this.gb = !1
  };

  function jd(a)
  {
    a.b()
  };

  function kd(a)
  {
    kd[" "](a);
    return a
  }
  kd[" "] = function() {};

  function ld(a, b)
  {
    id.call(this, a ? a.type : "");
    this.a = this.target = null;
    this.o = this.clientY = this.clientX = 0;
    this.B = this.v = !1;
    this.c = null;
    if (a)
    {
      this.type = a.type;
      var c = a.changedTouches ? a.changedTouches[0] : null;
      this.target = a.target || a.srcElement;
      this.a = b;
      var d = a.relatedTarget;
      if (d && Rc) try
      {
        kd(d.nodeName)
      }
      catch (e)
      {}
      null === c ? (this.clientX = void 0 !== a.clientX ? a.clientX : a.pageX, this.clientY = void 0 !== a.clientY ? a.clientY : a.pageY) : (this.clientX = void 0 !== c.clientX ? c.clientX : c.pageX, this.clientY = void 0 !== c.clientY ? c.clientY :
        c.pageY);
      this.o = a.keyCode || 0;
      this.v = a.ctrlKey;
      this.B = a.shiftKey;
      this.c = a;
      a.defaultPrevented && this.b()
    }
  }
  w(ld, id);
  var md = [1, 4, 2];
  ld.prototype.h = function()
  {
    ld.A.h.call(this);
    this.c.stopPropagation ? this.c.stopPropagation() : this.c.cancelBubble = !0
  };
  ld.prototype.b = function()
  {
    ld.A.b.call(this);
    var a = this.c;
    if (a.preventDefault) a.preventDefault();
    else if (a.returnValue = !1, dd) try
    {
      if (a.ctrlKey || 112 <= a.keyCode && 123 >= a.keyCode) a.keyCode = -1
    }
    catch (b)
    {}
  };
  var nd = !H || 9 <= Number(ad),
    od = !Rc && !H || H && 9 <= Number(ad) || Rc && I("1.9.1");
  H && I("9");

  function pd()
  {
    this.b = ""
  }
  pd.prototype.a = function()
  {
    return this.b
  };

  function qd(a)
  {
    var b = new pd;
    b.b = a;
    return b
  }
  qd("");

  function rd()
  {
    this.c = "";
    this.g = sd
  }
  rd.prototype.a = function()
  {
    return this.c
  };
  rd.prototype.b = function()
  {
    return 1
  };
  var sd = {};

  function td()
  {
    this.c = "";
    this.g = ud
  }
  td.prototype.a = function()
  {
    return this.c
  };
  td.prototype.b = function()
  {
    return 1
  };
  var ud = {};

  function vd()
  {
    this.c = "";
    this.h = wd;
    this.g = null
  }
  vd.prototype.b = function()
  {
    return this.g
  };
  vd.prototype.a = function()
  {
    return this.c
  };

  function xd(a)
  {
    return a instanceof vd && a.constructor === vd && a.h === wd ? a.c : "type_error:SafeHtml"
  }
  var wd = {};

  function yd(a)
  {
    var b = new vd;
    b.c = a;
    b.g = 0;
    return b
  }
  yd("\x3c!DOCTYPE html\x3e");
  var zd = yd("");
  yd("\x3cbr\x3e");

  function J(a, b)
  {
    this.x = q(a) ? a : 0;
    this.y = q(b) ? b : 0
  }
  J.prototype.clone = function()
  {
    return new J(this.x, this.y)
  };
  J.prototype.ceil = function()
  {
    this.x = Math.ceil(this.x);
    this.y = Math.ceil(this.y);
    return this
  };
  J.prototype.floor = function()
  {
    this.x = Math.floor(this.x);
    this.y = Math.floor(this.y);
    return this
  };
  J.prototype.round = function()
  {
    this.x = Math.round(this.x);
    this.y = Math.round(this.y);
    return this
  };

  function Ad(a, b)
  {
    this.width = a;
    this.height = b
  }
  g = Ad.prototype;
  g.clone = function()
  {
    return new Ad(this.width, this.height)
  };
  g.tb = function()
  {
    return this.width * this.height
  };
  g.isEmpty = function()
  {
    return !this.tb()
  };
  g.ceil = function()
  {
    this.width = Math.ceil(this.width);
    this.height = Math.ceil(this.height);
    return this
  };
  g.floor = function()
  {
    this.width = Math.floor(this.width);
    this.height = Math.floor(this.height);
    return this
  };
  g.round = function()
  {
    this.width = Math.round(this.width);
    this.height = Math.round(this.height);
    return this
  };

  function Bd(a)
  {
    return a ? new Cd(Dd(a)) : ja || (ja = new Cd)
  }

  function K(a, b)
  {
    var c = b || document,
      d = null;
    c.getElementsByClassName ? d = c.getElementsByClassName(a)[0] : c.querySelectorAll && c.querySelector ? d = c.querySelector("." + a) : d = Ed(a, b)[0];
    return d || null
  }

  function Ed(a, b)
  {
    var c, d, e, f;
    c = document;
    c = b || c;
    if (c.querySelectorAll && c.querySelector && a) return c.querySelectorAll("" + (a ? "." + a : ""));
    if (a && c.getElementsByClassName)
    {
      var h = c.getElementsByClassName(a);
      return h
    }
    h = c.getElementsByTagName("*");
    if (a)
    {
      f = {};
      for (d = e = 0; c = h[d]; d++)
      {
        var k = c.className;
        "function" == typeof k.split && Ba(k.split(/\s+/), a) && (f[e++] = c)
      }
      f.length = e;
      return f
    }
    return h
  }

  function Fd(a, b)
  {
    Ka(b, function(b, d)
    {
      "style" == d ? a.style.cssText = b : "class" == d ? a.className = b : "for" == d ? a.htmlFor = b : Gd.hasOwnProperty(d) ? a.setAttribute(Gd[d], b) : 0 == d.lastIndexOf("aria-", 0) || 0 == d.lastIndexOf("data-", 0) ? a.setAttribute(d, b) : a[d] = b
    })
  }
  var Gd = {
    cellpadding: "cellPadding",
    cellspacing: "cellSpacing",
    colspan: "colSpan",
    frameborder: "frameBorder",
    height: "height",
    maxlength: "maxLength",
    role: "role",
    rowspan: "rowSpan",
    type: "type",
    usemap: "useMap",
    valign: "vAlign",
    width: "width"
  };

  function Hd(a)
  {
    a = a.document.documentElement;
    return new Ad(a.clientWidth, a.clientHeight)
  }

  function Id(a)
  {
    return a ? Jd(a) : window
  }

  function Jd(a)
  {
    return a.parentWindow || a.defaultView
  }

  function Kd(a, b, c)
  {
    return Ld(document, arguments)
  }

  function Ld(a, b)
  {
    var c = b[0],
      d = b[1];
    if (!nd && d && (d.name || d.type))
    {
      c = ["\x3c", c];
      d.name && c.push(' name\x3d"', la(d.name), '"');
      if (d.type)
      {
        c.push(' type\x3d"', la(d.type), '"');
        var e = {};
        Oa(e, d);
        delete e.type;
        d = e
      }
      c.push("\x3e");
      c = c.join("")
    }
    c = a.createElement(c);
    d && (t(d) ? c.className = d : ba(d) ? c.className = d.join(" ") : Fd(c, d));
    2 < b.length && Md(a, c, b, 2);
    return c
  }

  function Md(a, b, c, d)
  {
    function e(c)
    {
      c && b.appendChild(t(c) ? a.createTextNode(c) : c)
    }
    for (; d < c.length; d++)
    {
      var f = c[d];
      !ca(f) || da(f) && 0 < f.nodeType ? e(f) : x(Nd(f) ? Ea(f) : f, e)
    }
  }

  function Od(a, b)
  {
    Md(Dd(a), a, arguments, 1)
  }

  function Pd(a)
  {
    return a && a.parentNode ? a.parentNode.removeChild(a) : null
  }

  function Dd(a)
  {
    return 9 == a.nodeType ? a : a.ownerDocument || a.document
  }

  function Qd(a, b)
  {
    if ("textContent" in a) a.textContent = b;
    else if (3 == a.nodeType) a.data = b;
    else if (a.firstChild && 3 == a.firstChild.nodeType)
    {
      for (; a.lastChild != a.firstChild;) a.removeChild(a.lastChild);
      a.firstChild.data = b
    }
    else
    {
      for (var c; c = a.firstChild;) a.removeChild(c);
      a.appendChild(Dd(a).createTextNode(String(b)))
    }
  }

  function Nd(a)
  {
    if (a && "number" == typeof a.length)
    {
      if (da(a)) return "function" == typeof a.item || "string" == typeof a.item;
      if ("function" == aa(a)) return "function" == typeof a.item
    }
    return !1
  }

  function Cd(a)
  {
    this.a = a || p.document || document
  }
  Cd.prototype.w = function(a)
  {
    return t(a) ? this.a.getElementById(a) : a
  };
  Cd.prototype.b = function(a, b, c)
  {
    return Ld(this.a, arguments)
  };

  function Rd(a)
  {
    var b = a.a;
    a = b.scrollingElement ? b.scrollingElement : Sc ? b.body || b.documentElement : b.documentElement;
    b = Jd(b);
    return H && I("10") && b.pageYOffset != a.scrollTop ? new J(a.scrollLeft, a.scrollTop) : new J(b.pageXOffset || a.scrollLeft, b.pageYOffset || a.scrollTop)
  }
  Cd.prototype.c = Pd;

  function Sd(a)
  {
    return od && void 0 != a.children ? a.children : za(a.childNodes, function(a)
    {
      return 1 == a.nodeType
    })
  }
  Cd.prototype.contains = function(a, b)
  {
    if (!a || !b) return !1;
    if (a.contains && 1 == b.nodeType) return a == b || a.contains(b);
    if ("undefined" != typeof a.compareDocumentPosition) return a == b || Boolean(a.compareDocumentPosition(b) & 16);
    for (; b && a != b;) b = b.parentNode;
    return b == a
  };
  var Td = "closure_listenable_" + (1E6 * Math.random() | 0);

  function Ud(a)
  {
    return !(!a || !a[Td])
  }
  var Vd = 0;

  function Wd(a, b, c, d, e)
  {
    this.listener = a;
    this.a = null;
    this.src = b;
    this.type = c;
    this.za = !!d;
    this.Ga = e;
    this.key = ++Vd;
    this.pa = this.ya = !1
  }

  function Xd(a)
  {
    a.pa = !0;
    a.listener = null;
    a.a = null;
    a.src = null;
    a.Ga = null
  };

  function Yd(a)
  {
    this.src = a;
    this.a = {};
    this.b = 0
  }

  function Zd(a, b, c, d, e, f)
  {
    var h = b.toString();
    b = a.a[h];
    b || (b = a.a[h] = [], a.b++);
    var k = $d(b, c, e, f); - 1 < k ? (a = b[k], d || (a.ya = !1)) : (a = new Wd(c, a.src, h, !!e, f), a.ya = d, b.push(a));
    return a
  }

  function ae(a, b)
  {
    var c = b.type;
    c in a.a && Ca(a.a[c], b) && (Xd(b), 0 == a.a[c].length && (delete a.a[c], a.b--))
  }

  function be(a, b, c, d, e)
  {
    a = a.a[b.toString()];
    b = -1;
    a && (b = $d(a, c, d, e));
    return -1 < b ? a[b] : null
  }

  function $d(a, b, c, d)
  {
    for (var e = 0; e < a.length; ++e)
    {
      var f = a[e];
      if (!f.pa && f.listener == b && f.za == !!c && f.Ga == d) return e
    }
    return -1
  };
  var ce = "closure_lm_" + (1E6 * Math.random() | 0),
    de = {},
    ee = 0;

  function L(a, b, c, d, e)
  {
    if (ba(b))
    {
      for (var f = 0; f < b.length; f++) L(a, b[f], c, d, e);
      return null
    }
    c = fe(c);
    return Ud(a) ? a.D(b, c, d, e) : ge(a, b, c, !1, d, e)
  }

  function ge(a, b, c, d, e, f)
  {
    if (!b) throw Error("Invalid event type");
    var h = !!e,
      k = he(a);
    k || (a[ce] = k = new Yd(a));
    c = Zd(k, b, c, d, e, f);
    if (c.a) return c;
    d = ie();
    c.a = d;
    d.src = a;
    d.listener = c;
    if (a.addEventListener) a.addEventListener(b.toString(), d, h);
    else if (a.attachEvent) a.attachEvent(je(b.toString()), d);
    else throw Error("addEventListener and attachEvent are unavailable.");
    ee++;
    return c
  }

  function ie()
  {
    var a = ke,
      b = cd ? function(c)
      {
        return a.call(b.src, b.listener, c)
      } : function(c)
      {
        c = a.call(b.src, b.listener, c);
        if (!c) return c
      };
    return b
  }

  function le(a, b, c, d, e)
  {
    if (ba(b))
      for (var f = 0; f < b.length; f++) le(a, b[f], c, d, e);
    else c = fe(c), Ud(a) ? Zd(a.g, String(b), c, !0, d, e) : ge(a, b, c, !0, d, e)
  }

  function me(a, b, c, d, e)
  {
    if (ba(b))
      for (var f = 0; f < b.length; f++) me(a, b[f], c, d, e);
    else c = fe(c), Ud(a) ? a.Ja(b, c, d, e) : a && (a = he(a)) && (b = be(a, b, c, !!d, e)) && ne(b)
  }

  function ne(a)
  {
    if ("number" != typeof a && a && !a.pa)
    {
      var b = a.src;
      if (Ud(b)) ae(b.g, a);
      else
      {
        var c = a.type,
          d = a.a;
        b.removeEventListener ? b.removeEventListener(c, d, a.za) : b.detachEvent && b.detachEvent(je(c), d);
        ee--;
        (c = he(b)) ? (ae(c, a), 0 == c.b && (c.src = null, b[ce] = null)) : Xd(a)
      }
    }
  }

  function je(a)
  {
    return a in de ? de[a] : de[a] = "on" + a
  }

  function oe(a, b, c, d)
  {
    var e = !0;
    if (a = he(a))
      if (b = a.a[b.toString()])
        for (b = b.concat(), a = 0; a < b.length; a++)
        {
          var f = b[a];
          f && f.za == c && !f.pa && (f = pe(f, d), e = e && !1 !== f)
        }
    return e
  }

  function pe(a, b)
  {
    var c = a.listener,
      d = a.Ga || a.src;
    a.ya && ne(a);
    return c.call(d, b)
  }

  function ke(a, b)
  {
    if (a.pa) return !0;
    if (!cd)
    {
      var c;
      if (!(c = b)) a:
      {
        c = ["window", "event"];
        for (var d = p, e; e = c.shift();)
          if (null != d[e]) d = d[e];
          else
          {
            c = null;
            break a
          } c = d
      }
      e = c;
      c = new ld(e, this);
      d = !0;
      if (!(0 > e.keyCode || void 0 != e.returnValue))
      {
        a:
        {
          var f = !1;
          if (0 == e.keyCode) try
          {
            e.keyCode = -1;
            break a
          }
          catch (l)
          {
            f = !0
          }
          if (f || void 0 == e.returnValue) e.returnValue = !0
        }
        e = [];
        for (f = c.a; f; f = f.parentNode) e.push(f);
        for (var f = a.type, h = e.length - 1; !c.j && 0 <= h; h--)
        {
          c.a = e[h];
          var k = oe(e[h], f, !0, c),
            d = d && k
        }
        for (h = 0; !c.j && h < e.length; h++) c.a = e[h],
        k = oe(e[h],
          f, !1, c),
        d = d && k
      }
      return d
    }
    return pe(a, new ld(b, this))
  }

  function he(a)
  {
    a = a[ce];
    return a instanceof Yd ? a : null
  }
  var qe = "__closure_events_fn_" + (1E9 * Math.random() >>> 0);

  function fe(a)
  {
    if ("function" == aa(a)) return a;
    a[qe] || (a[qe] = function(b)
    {
      return a.handleEvent(b)
    });
    return a[qe]
  };

  function re(a)
  {
    ed.call(this);
    this.b = a;
    this.a = {}
  }
  w(re, ed);
  var se = [];
  re.prototype.D = function(a, b, c, d)
  {
    ba(b) || (b && (se[0] = b.toString()), b = se);
    for (var e = 0; e < b.length; e++)
    {
      var f = L(a, b[e], c || this.handleEvent, d || !1, this.b || this);
      if (!f) break;
      this.a[f.key] = f
    }
    return this
  };
  re.prototype.Ja = function(a, b, c, d, e)
  {
    if (ba(b))
      for (var f = 0; f < b.length; f++) this.Ja(a, b[f], c, d, e);
    else c = c || this.handleEvent, e = e || this.b || this, c = fe(c), d = !!d, b = Ud(a) ? be(a.g, String(b), c, d, e) : a ? (a = he(a)) ? be(a, b, c, d, e) : null : null, b && (ne(b), delete this.a[b.key]);
    return this
  };

  function te(a)
  {
    Ka(a.a, function(a, c)
    {
      this.a.hasOwnProperty(c) && ne(a)
    }, a);
    a.a = {}
  }
  re.prototype.C = function()
  {
    re.A.C.call(this);
    te(this)
  };
  re.prototype.handleEvent = function()
  {
    throw Error("EventHandler.handleEvent not implemented");
  };

  function M()
  {
    ed.call(this);
    this.g = new Yd(this);
    this.Ka = this;
    this.X = null
  }
  w(M, ed);
  M.prototype[Td] = !0;
  g = M.prototype;
  g.Va = function(a)
  {
    this.X = a
  };
  g.removeEventListener = function(a, b, c, d)
  {
    me(this, a, b, c, d)
  };

  function N(a, b)
  {
    var c, d = a.X;
    if (d)
      for (c = []; d; d = d.X) c.push(d);
    var d = a.Ka,
      e = b,
      f = e.type || e;
    if (t(e)) e = new id(e, d);
    else if (e instanceof id) e.target = e.target || d;
    else
    {
      var h = e,
        e = new id(f, d);
      Oa(e, h)
    }
    var h = !0,
      k;
    if (c)
      for (var l = c.length - 1; !e.j && 0 <= l; l--) k = e.a = c[l], h = ue(k, f, !0, e) && h;
    e.j || (k = e.a = d, h = ue(k, f, !0, e) && h, e.j || (h = ue(k, f, !1, e) && h));
    if (c)
      for (l = 0; !e.j && l < c.length; l++) k = e.a = c[l], h = ue(k, f, !1, e) && h;
    return h
  }
  g.C = function()
  {
    M.A.C.call(this);
    if (this.g)
    {
      var a = this.g,
        b = 0,
        c;
      for (c in a.a)
      {
        for (var d = a.a[c], e = 0; e < d.length; e++) ++b, Xd(d[e]);
        delete a.a[c];
        a.b--
      }
    }
    this.X = null
  };
  g.D = function(a, b, c, d)
  {
    return Zd(this.g, String(a), b, !1, c, d)
  };
  g.Ja = function(a, b, c, d)
  {
    var e;
    e = this.g;
    a = String(a).toString();
    if (a in e.a)
    {
      var f = e.a[a];
      b = $d(f, b, c, d); - 1 < b ? (Xd(f[b]), Array.prototype.splice.call(f, b, 1), 0 == f.length && (delete e.a[a], e.b--), e = !0) : e = !1
    }
    else e = !1;
    return e
  };

  function ue(a, b, c, d)
  {
    b = a.g.a[String(b)];
    if (!b) return !0;
    b = b.concat();
    for (var e = !0, f = 0; f < b.length; ++f)
    {
      var h = b[f];
      if (h && !h.pa && h.za == c)
      {
        var k = h.listener,
          l = h.Ga || h.src;
        h.ya && ae(a.g, h);
        e = !1 !== k.call(l, d) && e
      }
    }
    return e && 0 != d.gb
  };

  function ve(a, b)
  {
    M.call(this);
    this.a = new re(this);
    var c = a;
    b && (c = Dd(a));
    this.a.D(c, "dragenter", this.Gb);
    c != a && this.a.D(c, "dragover", this.Hb);
    this.a.D(a, "dragover", this.Mb);
    this.a.D(a, "drop", this.Nb)
  }
  w(ve, M);
  g = ve.prototype;
  g.ta = !1;
  g.C = function()
  {
    ve.A.C.call(this);
    this.a.Z()
  };
  g.Gb = function(a)
  {
    var b = a.c.dataTransfer;
    (this.ta = !(!b || !(b.types && (Ba(b.types, "Files") || Ba(b.types, "public.file-url")) || b.files && 0 < b.files.length))) && a.b()
  };
  g.Hb = function(a)
  {
    this.ta && (a.b(), a.c.dataTransfer.dropEffect = "none")
  };
  g.Mb = function(a)
  {
    if (this.ta)
    {
      a.b();
      a.h();
      a = a.c.dataTransfer;
      try
      {
        a.effectAllowed = "all"
      }
      catch (b)
      {}
      a.dropEffect = "copy"
    }
  };
  g.Nb = function(a)
  {
    this.ta && (a.b(), a.h(), a = new ld(a.c), a.type = "drop", N(this, a))
  };
  var we = p.JSON.stringify;
  var xe = {},
    ye = {},
    ze = {};

  function O()
  {
    throw Error("Do not instantiate directly");
  }
  O.prototype.ba = null;
  O.prototype.getContent = function()
  {
    return this.content
  };
  O.prototype.toString = function()
  {
    return this.content
  };

  function Ae(a, b, c)
  {
    a.innerHTML = Be(b(c || Ce, void 0, void 0))
  }

  function De(a, b, c, d)
  {
    d = d || Bd();
    a = Be(a(b || Ce, void 0, c));
    c = d.a;
    b = c.createElement("DIV");
    H ? (b.innerHTML = "\x3cbr\x3e" + a, b.removeChild(b.firstChild)) : b.innerHTML = a;
    if (1 == b.childNodes.length) a = b.removeChild(b.firstChild);
    else
      for (a = c.createDocumentFragment(); b.firstChild;) a.appendChild(b.firstChild);
    return a
  }

  function Be(a)
  {
    if (!da(a)) return String(a);
    if (a instanceof O)
    {
      if (a.T === xe) return a.getContent();
      if (a.T === ze) return la(a.getContent())
    }
    return "zSoyz"
  }
  var Ce = {};
  var Ee;

  function Fe(a, b)
  {
    b ? a.setAttribute("role", b) : a.removeAttribute("role")
  }

  function Ge(a, b, c)
  {
    ba(c) && (c = c.join(" "));
    var d = "aria-" + b;
    "" === c || void 0 == c ? (Ee || (Ee = {
      atomic: !1,
      autocomplete: "none",
      dropeffect: "none",
      haspopup: !1,
      live: "off",
      multiline: !1,
      multiselectable: !1,
      orientation: "vertical",
      readonly: !1,
      relevant: "additions text",
      required: !1,
      sort: "none",
      busy: !1,
      disabled: !1,
      hidden: !1,
      invalid: "false"
    }), c = Ee, b in c ? a.setAttribute(d, c[b]) : a.removeAttribute(d)) : a.setAttribute(d, c)
  };

  function He(a)
  {
    if (a.classList) return a.classList;
    a = a.className;
    return t(a) && a.match(/\S+/g) || []
  }

  function Ie(a, b)
  {
    return a.classList ? a.classList.contains(b) : Ba(He(a), b)
  }

  function Je(a, b)
  {
    if (a.classList) x(b, function(b)
    {
      a.classList ? a.classList.add(b) : Ie(a, b) || (a.className += 0 < a.className.length ? " " + b : b)
    });
    else
    {
      var c = {};
      x(He(a), function(a)
      {
        c[a] = !0
      });
      x(b, function(a)
      {
        c[a] = !0
      });
      a.className = "";
      for (var d in c) a.className += 0 < a.className.length ? " " + d : d
    }
  }

  function Ke(a, b)
  {
    a.classList ? a.classList.remove(b) : Ie(a, b) && (a.className = za(He(a), function(a)
    {
      return a != b
    }).join(" "))
  }

  function Le(a, b)
  {
    a.classList ? x(b, function(b)
    {
      Ke(a, b)
    }) : a.className = za(He(a), function(a)
    {
      return !Ba(b, a)
    }).join(" ")
  };

  function Me(a, b, c, d)
  {
    this.top = a;
    this.right = b;
    this.bottom = c;
    this.left = d
  }
  g = Me.prototype;
  g.clone = function()
  {
    return new Me(this.top, this.right, this.bottom, this.left)
  };
  g.contains = function(a)
  {
    return this && a ? a instanceof Me ? a.left >= this.left && a.right <= this.right && a.top >= this.top && a.bottom <= this.bottom : a.x >= this.left && a.x <= this.right && a.y >= this.top && a.y <= this.bottom : !1
  };
  g.ceil = function()
  {
    this.top = Math.ceil(this.top);
    this.right = Math.ceil(this.right);
    this.bottom = Math.ceil(this.bottom);
    this.left = Math.ceil(this.left);
    return this
  };
  g.floor = function()
  {
    this.top = Math.floor(this.top);
    this.right = Math.floor(this.right);
    this.bottom = Math.floor(this.bottom);
    this.left = Math.floor(this.left);
    return this
  };
  g.round = function()
  {
    this.top = Math.round(this.top);
    this.right = Math.round(this.right);
    this.bottom = Math.round(this.bottom);
    this.left = Math.round(this.left);
    return this
  };

  function Ne(a, b, c, d)
  {
    this.left = a;
    this.top = b;
    this.width = c;
    this.height = d
  }
  g = Ne.prototype;
  g.clone = function()
  {
    return new Ne(this.left, this.top, this.width, this.height)
  };
  g.contains = function(a)
  {
    return a instanceof Ne ? this.left <= a.left && this.left + this.width >= a.left + a.width && this.top <= a.top && this.top + this.height >= a.top + a.height : a.x >= this.left && a.x <= this.left + this.width && a.y >= this.top && a.y <= this.top + this.height
  };
  g.distance = function(a)
  {
    var b = a.x < this.left ? this.left - a.x : Math.max(a.x - (this.left + this.width), 0);
    a = a.y < this.top ? this.top - a.y : Math.max(a.y - (this.top + this.height), 0);
    return Math.sqrt(b * b + a * a)
  };
  g.getCenter = function()
  {
    return new J(this.left + this.width / 2, this.top + this.height / 2)
  };
  g.ceil = function()
  {
    this.left = Math.ceil(this.left);
    this.top = Math.ceil(this.top);
    this.width = Math.ceil(this.width);
    this.height = Math.ceil(this.height);
    return this
  };
  g.floor = function()
  {
    this.left = Math.floor(this.left);
    this.top = Math.floor(this.top);
    this.width = Math.floor(this.width);
    this.height = Math.floor(this.height);
    return this
  };
  g.round = function()
  {
    this.left = Math.round(this.left);
    this.top = Math.round(this.top);
    this.width = Math.round(this.width);
    this.height = Math.round(this.height);
    return this
  };

  function Oe(a, b, c)
  {
    var d = Pe[c];
    if (!d)
    {
      var e = wa(c),
        d = e;
      void 0 === a.style[e] && (e = (Sc ? "Webkit" : Rc ? "Moz" : H ? "ms" : Pc ? "O" : null) + xa(e), void 0 !== a.style[e] && (d = e));
      Pe[c] = d
    }(c = d) && (a.style[c] = b)
  }
  var Pe = {};

  function Qe(a, b)
  {
    var c = Dd(a);
    return c.defaultView && c.defaultView.getComputedStyle && (c = c.defaultView.getComputedStyle(a, null)) ? c[b] || c.getPropertyValue(b) || "" : ""
  }

  function Re(a, b)
  {
    return Qe(a, b) || (a.currentStyle ? a.currentStyle[b] : null) || a.style && a.style[b]
  }

  function Se(a, b, c)
  {
    var d;
    b instanceof J ? (d = b.x, b = b.y) : (d = b, b = c);
    a.style.left = Te(d, !1);
    a.style.top = Te(b, !1)
  }

  function Ue(a)
  {
    var b;
    try
    {
      b = a.getBoundingClientRect()
    }
    catch (c)
    {
      return {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      }
    }
    H && a.ownerDocument.body && (a = a.ownerDocument, b.left -= a.documentElement.clientLeft + a.body.clientLeft, b.top -= a.documentElement.clientTop + a.body.clientTop);
    return b
  }

  function Ve(a, b)
  {
    var c = We(a),
      d = We(b);
    return new J(c.x - d.x, c.y - d.y)
  }

  function We(a)
  {
    if (1 == a.nodeType) return a = Ue(a), new J(a.left, a.top);
    a = a.changedTouches ? a.changedTouches[0] : a;
    return new J(a.clientX, a.clientY)
  }

  function Xe(a, b, c)
  {
    if (b instanceof Ad) c = b.height, b = b.width;
    else if (void 0 == c) throw Error("missing height argument");
    a.style.width = Te(b, !0);
    a.style.height = Te(c, !0)
  }

  function Te(a, b)
  {
    "number" == typeof a && (a = (b ? Math.round(a) : a) + "px");
    return a
  }

  function Ye(a)
  {
    var b = Ze;
    if ("none" != Re(a, "display")) return b(a);
    var c = a.style,
      d = c.display,
      e = c.visibility,
      f = c.position;
    c.visibility = "hidden";
    c.position = "absolute";
    c.display = "inline";
    a = b(a);
    c.display = d;
    c.position = f;
    c.visibility = e;
    return a
  }

  function Ze(a)
  {
    var b = a.offsetWidth,
      c = a.offsetHeight,
      d = Sc && !b && !c;
    return q(b) && !d || !a.getBoundingClientRect ? new Ad(b, c) : (a = Ue(a), new Ad(a.right - a.left, a.bottom - a.top))
  }

  function $e(a, b)
  {
    var c = a.style;
    "opacity" in c ? c.opacity = b : "MozOpacity" in c ? c.MozOpacity = b : "filter" in c && (c.filter = "" === b ? "" : "alpha(opacity\x3d" + 100 * Number(b) + ")")
  }

  function P(a, b)
  {
    a.style.display = b ? "" : "none"
  }

  function af(a)
  {
    return "rtl" == Re(a, "direction")
  }
  var bf = {
    thin: 2,
    medium: 4,
    thick: 6
  };

  function cf(a, b)
  {
    if ("none" == (a.currentStyle ? a.currentStyle[b + "Style"] : null)) return 0;
    var c = a.currentStyle ? a.currentStyle[b + "Width"] : null,
      d;
    if (c in bf) d = bf[c];
    else if (/^\d+px?$/.test(c)) d = parseInt(c, 10);
    else
    {
      d = a.style.left;
      var e = a.runtimeStyle.left;
      a.runtimeStyle.left = a.currentStyle.left;
      a.style.left = c;
      c = a.style.pixelLeft;
      a.style.left = d;
      a.runtimeStyle.left = e;
      d = c
    }
    return d
  }

  function df(a)
  {
    if (H && !(9 <= Number(ad)))
    {
      var b = cf(a, "borderLeft"),
        c = cf(a, "borderRight"),
        d = cf(a, "borderTop");
      a = cf(a, "borderBottom");
      return new Me(d, c, a, b)
    }
    b = Qe(a, "borderLeftWidth");
    c = Qe(a, "borderRightWidth");
    d = Qe(a, "borderTopWidth");
    a = Qe(a, "borderBottomWidth");
    return new Me(parseFloat(d), parseFloat(c), parseFloat(a), parseFloat(b))
  };

  function ef(a, b, c)
  {
    M.call(this);
    this.target = a;
    this.B = b || a;
    this.v = c || new Ne(NaN, NaN, NaN, NaN);
    this.j = Dd(a);
    this.a = new re(this);
    a = v(hd, this.a);
    this.o ? a.call(void 0) : (this.m || (this.m = []), this.m.push(q(void 0) ? u(a, void 0) : a));
    this.h = this.c = this.fa = this.Y = this.clientY = this.clientX = 0;
    this.K = !0;
    this.b = !1;
    this.O = !0;
    this.M = 0;
    this.F = this.ra = !1;
    L(this.B, ["touchstart", "mousedown"], this.hb, !1, this)
  }
  w(ef, M);
  var ff = p.document && p.document.documentElement && !!p.document.documentElement.setCapture;
  g = ef.prototype;
  g.C = function()
  {
    ef.A.C.call(this);
    me(this.B, ["touchstart", "mousedown"], this.hb, !1, this);
    te(this.a);
    ff && this.j.releaseCapture();
    this.B = this.target = null
  };

  function gf(a)
  {
    q(a.L) || (a.L = af(a.target));
    return a.L
  }
  g.hb = function(a)
  {
    var b = "mousedown" == a.type;
    if (!this.K || this.b || b && (!(bd ? 0 == a.c.button : "click" == a.type || a.c.button & md[0]) || Sc && Tc && a.v)) N(this, "earlycancel");
    else
    {
      if (0 == this.M)
        if (N(this, new hf("start", this, a.clientX, a.clientY))) this.b = !0, this.O && a.b();
        else return;
      else this.O && a.b();
      var b = this.j,
        c = b.documentElement,
        d = !ff;
      this.a.D(b, ["touchmove", "mousemove"], this.yb, d);
      this.a.D(b, ["touchend", "mouseup"], this.Ba, d);
      ff ? (c.setCapture(!1), this.a.D(c, "losecapture", this.Ba)) : this.a.D(Id(b), "blur", this.Ba);
      H && this.ra && this.a.D(b, "dragstart", jd);
      this.sa && this.a.D(this.sa, "scroll", this.$b, d);
      this.clientX = this.Y = a.clientX;
      this.clientY = this.fa = a.clientY;
      this.F ? (a = this.target, b = a.offsetLeft, c = a.offsetParent, c || "fixed" != Re(a, "position") || (c = Dd(a).documentElement), c ? (Rc ? (d = df(c), b += d.left) : 8 <= Number(ad) && !(9 <= Number(ad)) && (d = df(c), b -= d.left), a = af(c) ? c.clientWidth - (b + a.offsetWidth) : b) : a = b) : a = this.target.offsetLeft;
      this.c = a;
      this.h = this.target.offsetTop;
      this.H = Rd(Bd(this.j))
    }
  };
  g.Ba = function(a)
  {
    te(this.a);
    ff && this.j.releaseCapture();
    this.b ? (this.b = !1, N(this, new hf("end", this, a.clientX, a.clientY, 0, jf(this, this.c), kf(this, this.h)))) : N(this, "earlycancel")
  };
  g.yb = function(a)
  {
    if (this.K)
    {
      var b = (this.F && gf(this) ? -1 : 1) * (a.clientX - this.clientX),
        c = a.clientY - this.clientY;
      this.clientX = a.clientX;
      this.clientY = a.clientY;
      if (!this.b)
      {
        var d = this.Y - this.clientX,
          e = this.fa - this.clientY;
        if (d * d + e * e > this.M)
          if (N(this, new hf("start", this, a.clientX, a.clientY))) this.b = !0;
          else
          {
            this.wa() || this.Ba(a);
            return
          }
      }
      c = lf(this, b, c);
      b = c.x;
      c = c.y;
      this.b && N(this, new hf("beforedrag", this, a.clientX, a.clientY, 0, b, c)) && (mf(this, a, b, c), a.b())
    }
  };

  function lf(a, b, c)
  {
    var d = Rd(Bd(a.j));
    b += d.x - a.H.x;
    c += d.y - a.H.y;
    a.H = d;
    a.c += b;
    a.h += c;
    return new J(jf(a, a.c), kf(a, a.h))
  }
  g.$b = function(a)
  {
    var b = lf(this, 0, 0);
    a.clientX = this.clientX;
    a.clientY = this.clientY;
    mf(this, a, b.x, b.y)
  };

  function mf(a, b, c, d)
  {
    a.F && gf(a) ? a.target.style.right = c + "px" : a.target.style.left = c + "px";
    a.target.style.top = d + "px";
    N(a, new hf("drag", a, b.clientX, b.clientY, 0, c, d))
  }

  function jf(a, b)
  {
    var c = a.v,
      d = isNaN(c.left) ? null : c.left,
      c = isNaN(c.width) ? 0 : c.width;
    return Math.min(null != d ? d + c : Infinity, Math.max(null != d ? d : -Infinity, b))
  }

  function kf(a, b)
  {
    var c = a.v,
      d = isNaN(c.top) ? null : c.top,
      c = isNaN(c.height) ? 0 : c.height;
    return Math.min(null != d ? d + c : Infinity, Math.max(null != d ? d : -Infinity, b))
  }

  function hf(a, b, c, d, e, f, h)
  {
    id.call(this, a);
    this.clientX = c;
    this.clientY = d;
    this.left = q(f) ? f : b.c;
    this.top = q(h) ? h : b.h
  }
  w(hf, id);

  function nf(a, b)
  {
    if ("function" == aa(a)) b && (a = u(a, b));
    else if (a && "function" == typeof a.handleEvent) a = u(a.handleEvent, a);
    else throw Error("Invalid listener argument");
    2147483647 < Number(0) || p.setTimeout(a, 0)
  };
  var of = H ? 'javascript:""' : "about:blank";

  function pf(a)
  {
    M.call(this);
    this.a = a;
    a = H ? "focusout" : "blur";
    this.b = L(this.a, H ? "focusin" : "focus", this, !H);
    this.c = L(this.a, a, this, !H)
  }
  w(pf, M);
  pf.prototype.handleEvent = function(a)
  {
    var b = new ld(a.c);
    b.type = "focusin" == a.type || "focus" == a.type ? "focusin" : "focusout";
    N(this, b)
  };
  pf.prototype.C = function()
  {
    pf.A.C.call(this);
    ne(this.b);
    ne(this.c);
    delete this.a
  };

  function qf()
  {}
  qf.b = function()
  {
    return qf.a ? qf.a : qf.a = new qf
  };
  qf.prototype.a = 0;

  function rf(a)
  {
    M.call(this);
    this.a = a || Bd();
    this.Y = null;
    this.V = !1;
    this.b = null;
    this.h = void 0;
    this.M = this.O = this.v = null;
    this.sa = !1
  }
  w(rf, M);
  g = rf.prototype;
  g.zb = qf.b();
  g.getId = function()
  {
    return this.Y || (this.Y = ":" + (this.zb.a++).toString(36))
  };
  g.w = function()
  {
    return this.b
  };

  function sf(a)
  {
    a.h || (a.h = new re(a));
    return a.h
  }
  g.Va = function(a)
  {
    if (this.v && this.v != a) throw Error("Method not supported");
    rf.A.Va.call(this, a)
  };
  g.va = function()
  {
    this.b = this.a.a.createElement("DIV")
  };

  function tf(a)
  {
    if (a.V) throw Error("Component already rendered");
    a.b || a.va();
    a.a.a.body.appendChild(a.b);
    a.v && !a.v.V || a.ma()
  }
  g.ma = function()
  {
    this.V = !0;
    uf(this, function(a)
    {
      !a.V && a.w() && a.ma()
    })
  };
  g.ga = function()
  {
    uf(this, function(a)
    {
      a.V && a.ga()
    });
    this.h && te(this.h);
    this.V = !1
  };
  g.C = function()
  {
    this.V && this.ga();
    this.h && (this.h.Z(), delete this.h);
    uf(this, function(a)
    {
      a.Z()
    });
    !this.sa && this.b && Pd(this.b);
    this.v = this.b = this.M = this.O = null;
    rf.A.C.call(this)
  };
  g.U = function()
  {
    return this.b
  };

  function uf(a, b)
  {
    a.O && x(a.O, b, void 0)
  }
  g.removeChild = function(a, b)
  {
    if (a)
    {
      var c = t(a) ? a : a.getId(),
        d;
      this.M && c ? (d = this.M, d = (null !== d && c in d ? d[c] : void 0) || null) : d = null;
      a = d;
      if (c && a)
      {
        d = this.M;
        c in d && delete d[c];
        Ca(this.O, a);
        b && (a.ga(), a.b && Pd(a.b));
        c = a;
        if (null == c) throw Error("Unable to set parent component");
        c.v = null;
        rf.A.Va.call(c, null)
      }
    }
    if (!a) throw Error("Child is not in parent component");
    return a
  };

  function vf(a, b)
  {
    this.c = a;
    this.b = b
  };

  function wf(a, b)
  {
    rf.call(this, b);
    this.ra = !!a;
    this.B = null
  }
  w(wf, rf);
  g = wf.prototype;
  g.Ra = null;
  g.la = !1;
  g.N = null;
  g.G = null;
  g.R = null;
  g.Ma = !1;
  g.Da = function()
  {
    return "goog-modalpopup"
  };
  g.Ca = function()
  {
    return this.N
  };
  g.va = function()
  {
    wf.A.va.call(this);
    var a = this.w(),
      b = ka(this.Da()).split(" ");
    Je(a, b);
    a.tabIndex = 0;
    P(a, !1);
    this.ra && !this.G && (a = this.a, b = t(void 0) ? qd(void 0).a() : "", this.G = a.b("iframe",
    {
      frameborder: 0,
      style: "border:0;vertical-align:bottom;" + b,
      src: of
    }), this.G.className = this.Da() + "-bg", P(this.G, !1), $e(this.G, 0));
    this.N || (this.N = this.a.b("DIV", this.Da() + "-bg"), P(this.N, !1));
    this.R || (this.R = this.a.a.createElement("SPAN"), P(this.R, !1), this.R.tabIndex = 0, this.R.style.position = "absolute")
  };
  g.fb = function()
  {
    this.Ma = !1
  };
  g.ma = function()
  {
    if (this.G)
    {
      var a = this.w();
      a.parentNode && a.parentNode.insertBefore(this.G, a)
    }
    a = this.w();
    a.parentNode && a.parentNode.insertBefore(this.N, a);
    wf.A.ma.call(this);
    a = this.w();
    a.parentNode && a.parentNode.insertBefore(this.R, a.nextSibling);
    this.Ra = new pf(this.a.a);
    sf(this).D(this.Ra, "focusin", this.Pb);
    xf(this, !1)
  };
  g.ga = function()
  {
    this.la && this.I(!1);
    hd(this.Ra);
    wf.A.ga.call(this);
    Pd(this.G);
    Pd(this.N);
    Pd(this.R)
  };
  g.I = function(a)
  {
    if (a != this.la)
      if (this.F && this.F.stop(), this.L && this.L.stop(), this.H && this.H.stop(), this.K && this.K.stop(), this.V && xf(this, a), a)
      {
        if (N(this, "beforeshow"))
        {
          try
          {
            this.B = this.a.a.activeElement
          }
          catch (e)
          {}
          this.Ua();
          var b = Id(this.a.a) || window;
          if ("fixed" == Re(this.w(), "position")) var c = a = 0;
          else c = Rd(this.a), a = c.x, c = c.y;
          var d = Ye(this.w()),
            b = Hd(b || window);
          a = Math.max(a + b.width / 2 - d.width / 2, 0);
          c = Math.max(c + b.height / 2 - d.height / 2, 0);
          Se(this.w(), a, c);
          Se(this.R, a, c);
          sf(this).D(Jd(this.a.a), "resize", this.Ua);
          yf(this, !0);
          this.$a();
          this.la = !0;
          this.F && this.L ? (le(this.F, "end", this.Fa, !1, this), this.L.play(), this.F.play()) : this.Fa()
        }
      }
    else if (N(this, "beforehide"))
    {
      sf(this).Ja(Jd(this.a.a), "resize", this.Ua);
      this.la = !1;
      this.H && this.K ? (le(this.H, "end", this.Ea, !1, this), this.K.play(), this.H.play()) : this.Ea();
      a:
      {
        try
        {
          c = this.a;
          d = c.a.body;
          b = c.a.activeElement || d;
          if (!this.B || this.B == d)
          {
            this.B = null;
            break a
          }(b == d || c.contains(this.w(), b)) && this.B.focus()
        }
        catch (e)
        {}
        this.B = null
      }
    }
  };

  function xf(a, b)
  {
    a.fa || (a.fa = new vf(a.b, a.a));
    var c = a.fa;
    if (b)
    {
      c.a || (c.a = []);
      for (var d = Sd(c.b.a.body), e = 0; e < d.length; e++)
      {
        var f = d[e],
          h;
        if (h = f != c.c) h = f.getAttribute("aria-hidden"), h = !(null == h || void 0 == h ? 0 : String(h));
        h && (Ge(f, "hidden", !0), c.a.push(f))
      }
    }
    else if (c.a)
    {
      for (e = 0; e < c.a.length; e++) c.a[e].removeAttribute("aria-hidden");
      c.a = null
    }
  }

  function yf(a, b)
  {
    a.G && P(a.G, b);
    a.N && P(a.N, b);
    P(a.w(), b);
    P(a.R, b)
  }
  g.Fa = function()
  {
    N(this, "show")
  };
  g.Ea = function()
  {
    yf(this, !1);
    N(this, "hide")
  };
  g.Ua = function()
  {
    this.G && P(this.G, !1);
    this.N && P(this.N, !1);
    var a = this.a.a,
      b = Hd(Id(a) || window || window),
      c = Math.max(b.width, Math.max(a.body.scrollWidth, a.documentElement.scrollWidth)),
      a = Math.max(b.height, Math.max(a.body.scrollHeight, a.documentElement.scrollHeight));
    this.G && (P(this.G, !0), Xe(this.G, c, a));
    this.N && (P(this.N, !0), Xe(this.N, c, a))
  };
  g.Pb = function(a)
  {
    this.Ma ? this.fb() : a.target == this.R && nf(this.$a, this)
  };
  g.$a = function()
  {
    try
    {
      H && this.a.a.body.focus(), this.w().focus()
    }
    catch (a)
    {}
  };
  g.C = function()
  {
    hd(this.F);
    this.F = null;
    hd(this.H);
    this.H = null;
    hd(this.L);
    this.L = null;
    hd(this.K);
    this.K = null;
    wf.A.C.call(this)
  };

  function Q(a, b, c)
  {
    wf.call(this, b, c);
    this.j = a || "xc-modal-dialog";
    this.c = R(R(new S, zf, !0), Af, !1, !0)
  }
  w(Q, wf);
  g = Q.prototype;
  g.wb = !0;
  g.ab = !0;
  g.bb = !0;
  g.vb = !0;
  g.La = .5;
  g.Wa = "";
  g.Aa = null;
  g.ca = null;
  g.ub = !1;
  g.qa = null;
  g.ka = null;
  g.ib = null;
  g.aa = null;
  g.Oa = null;
  g.S = null;
  g.eb = "dialog";
  g.Da = function()
  {
    return this.j
  };
  g.setTitle = function(a)
  {
    this.Wa = a;
    this.ka && Qd(this.ka, a)
  };
  g.getTitle = function()
  {
    return this.Wa
  };
  g.getContent = function()
  {
    return null != this.Aa ? xd(this.Aa) : ""
  };
  g.U = function()
  {
    this.w() || tf(this);
    return this.Oa
  };
  g.Ca = function()
  {
    this.w() || tf(this);
    return Q.A.Ca.call(this)
  };

  function Bf(a, b)
  {
    var c = ka(a.j + "-title-draggable").split(" ");
    a.w() && (b ? Je(a.qa, c) : Le(a.qa, c));
    b && !a.ca ? (a.ca = new ef(a.w(), a.qa), Je(a.qa, c), L(a.ca, "start", a.jc, !1, a)) : !b && a.ca && (a.ca.Z(), a.ca = null)
  }
  g.va = function()
  {
    Q.A.va.call(this);
    var a = this.w(),
      b = this.a;
    this.qa = b.b("DIV", this.j + "-title", this.ka = b.b("SPAN",
    {
      className: this.j + "-title-text",
      id: this.getId()
    }, this.Wa), this.aa = b.b("SPAN", this.j + "-title-close"));
    Od(a, this.qa, this.Oa = b.b("DIV", this.j + "-content"), this.S = b.b("DIV", this.j + "-buttons"));
    Fe(this.ka, "heading");
    Fe(this.aa, "button");
    this.aa.tabIndex = 0;
    Ge(this.aa, "label", Cf);
    this.ib = this.ka.id;
    Fe(a, this.eb);
    Ge(a, "labelledby", this.ib || "");
    this.Aa && (this.Oa.innerHTML = xd(this.Aa));
    P(this.aa, this.ab);
    this.c && (a = this.c, a.ea = this.S, Df(a));
    P(this.S, !!this.c);
    this.La = this.La;
    this.w() && (a = this.Ca()) && $e(a, this.La)
  };
  g.ma = function()
  {
    Q.A.ma.call(this);
    sf(this).D(this.w(), "keydown", this.cb).D(this.w(), "keypress", this.cb);
    sf(this).D(this.S, "click", this.Eb);
    Bf(this, this.vb);
    sf(this).D(this.aa, "click", this.fc);
    var a = this.w();
    Fe(a, this.eb);
    "" !== this.ka.id && Ge(a, "labelledby", this.ka.id);
    if (!this.bb)
    {
      this.bb = !1;
      if (this.V)
      {
        var a = this.a,
          b = this.Ca();
        a.c(this.G);
        a.c(b)
      }
      this.la && xf(this, !1)
    }
  };
  g.ga = function()
  {
    this.la && this.I(!1);
    Bf(this, !1);
    Q.A.ga.call(this)
  };
  g.I = function(a)
  {
    a != this.la && (this.V || tf(this), Q.A.I.call(this, a))
  };
  g.Fa = function()
  {
    Q.A.Fa.call(this);
    N(this, Ef)
  };
  g.Ea = function()
  {
    Q.A.Ea.call(this);
    N(this, Ff);
    this.ub && this.Z()
  };
  g.jc = function()
  {
    var a = this.a.a,
      b = Hd(Id(a) || window || window),
      c = Math.max(a.body.scrollWidth, b.width),
      a = Math.max(a.body.scrollHeight, b.height),
      d = Ye(this.w());
    "fixed" == Re(this.w(), "position") ? this.ca.v = new Ne(0, 0, Math.max(0, b.width - d.width), Math.max(0, b.height - d.height)) || new Ne(NaN, NaN, NaN, NaN) : this.ca.v = new Ne(0, 0, c - d.width, a - d.height) || new Ne(NaN, NaN, NaN, NaN)
  };
  g.fc = function()
  {
    Gf(this)
  };

  function Gf(a)
  {
    if (a.ab)
    {
      var b = a.c,
        c = b && b.Na;
      c ? N(a, new Hf(c, Ua(b, c))) && a.I(!1) : a.I(!1)
    }
  }
  g.C = function()
  {
    this.S = this.aa = null;
    Q.A.C.call(this)
  };

  function If(a, b)
  {
    a.c = b;
    if (a.S)
    {
      if (a.c)
      {
        var c = a.c;
        c.ea = a.S;
        Df(c)
      }
      else a.S.innerHTML = xd(zd);
      P(a.S, !!a.c)
    }
  }
  g.Eb = function(a)
  {
    a:
    {
      for (a = a.target; null != a && a != this.S;)
      {
        if ("BUTTON" == a.tagName) break a;
        a = a.parentNode
      }
      a = null
    }
    a && !a.disabled && (a = a.name, N(this, new Hf(a, Ua(this.c, a))) && this.I(!1))
  };
  g.cb = function(a)
  {
    var b = !1,
      c = !1,
      d = this.c,
      e = a.target;
    if ("keydown" == a.type)
      if (this.wb && 27 == a.o)
      {
        var f = d && d.Na,
          e = "SELECT" == e.tagName && !e.disabled;
        f && !e ? (c = !0, b = N(this, new Hf(f, Ua(d, f)))) : e || (b = !0)
      }
    else
    {
      if (9 == a.o && a.B && e == this.w())
      {
        this.Ma = !0;
        try
        {
          this.R.focus()
        }
        catch (m)
        {}
        nf(this.fb, this)
      }
    }
    else if (13 == a.o)
    {
      if ("BUTTON" == e.tagName && !e.disabled) f = e.name;
      else if (e == this.aa) Gf(this);
      else if (d)
      {
        var h = d.Pa,
          k;
        if (k = h) a:
        {
          k = d.ea.getElementsByTagName("BUTTON");
          for (var l = 0, n; n = k[l]; l++)
            if (n.name == h || n.id == h)
            {
              k = n;
              break a
            } k =
          null
        }
        e = ("TEXTAREA" == e.tagName || "SELECT" == e.tagName || "A" == e.tagName) && !e.disabled;
        !k || k.disabled || e || (f = h)
      }
      f && d && (c = !0, b = N(this, new Hf(f, String(Ua(d, f)))))
    }
    else e == this.aa && 32 == a.o && Gf(this);
    if (b || c) a.h(), a.b();
    b && this.I(!1)
  };

  function Hf(a, b)
  {
    this.type = Jf;
    this.key = a;
    this.caption = b
  }
  w(Hf, id);
  var Jf = "dialogselect",
    Ff = "afterhide",
    Ef = "aftershow";

  function S(a)
  {
    a || Bd();
    Ra.call(this)
  }
  w(S, Ra);
  g = S.prototype;
  g.xb = "goog-buttonset";
  g.Pa = null;
  g.ea = null;
  g.Na = null;
  g.da = function(a, b, c, d)
  {
    Ra.prototype.da.call(this, a, b);
    c && (this.Pa = a);
    d && (this.Na = a);
    return this
  };

  function R(a, b, c, d)
  {
    return a.da(b.key, b.caption, c, d)
  }

  function Df(a)
  {
    if (a.ea)
    {
      a.ea.innerHTML = xd(zd);
      var b = Bd(a.ea);
      a.forEach(function(a, d)
      {
        var e = b.b("BUTTON",
        {
          name: d
        }, a);
        d == this.Pa && (e.className = this.xb + "-default");
        this.ea.appendChild(e)
      }, a)
    }
  }
  g.w = function()
  {
    return this.ea
  };
  var Cf = "Close",
    zf = {
      key: "ok",
      caption: $pgettext('general', 'OK')
    },
    Af = {
      key: "cancel",
      caption: $pgettext('general', 'Cancel')
    },
    Kf = {
      key: "yes",
      caption: $pgettext('general', 'Yes')
    },
    Lf = {
      key: "no",
      caption: $pgettext('general', 'No')
    },
    Mf = {
      key: "save",
      caption: $pgettext('general', 'Save')
    },
    Nf = {
      key: "continue",
      caption: $pgettext('general', 'Continue')
    };
  "undefined" != typeof document && (R(new S, zf, !0, !0), R(R(new S, zf, !0), Af, !1, !0), R(R(new S, Kf, !0), Lf, !1, !0), R(R(R(new S, Kf), Lf, !0), Af, !1, !0), R(R(R(new S, Nf), Mf), Af, !0, !0));
  var Of = /^B\d{13}[NS]\d{8}[EW][AV]\d{10}/gm,
    Pf = /^B\d{6}(\d\d)(\d{5})([NS])(\d{3})(\d{5})([EW])[AV]\d{10}$/;

  function Qf(a)
  {
    var b = [];
    a = a.match(Of);
    x(a, function(a)
    {
      a = Pf.exec(a);
      if (null !== a)
      {
        var d = parseInt(a[1], 10) + parseInt(a[2], 10) / 6E4;
        "S" == a[3] && (d = -d);
        var e = parseInt(a[4], 10) + parseInt(a[5], 10) / 6E4;
        "W" == a[6] && (e = -e);
        b.push(new google.maps.LatLng(d, e))
      }
    });
    return b
  };
  H && I(8);

  function Rf(a)
  {
    if (null != a) switch (a.ba)
    {
      case 1:
        return 1;
      case -1:
        return -1;
      case 0:
        return 0
    }
    return null
  }

  function Sf()
  {
    O.call(this)
  }
  w(Sf, O);
  Sf.prototype.T = xe;

  function T(a)
  {
    return null != a && a.T === xe ? a : a instanceof vd ? Tf(xd(a), a.b()) : Tf(la(String(String(a))), Rf(a))
  }

  function Uf()
  {
    O.call(this)
  }
  w(Uf, O);
  Uf.prototype.T = {};
  Uf.prototype.ba = 1;

  function Vf()
  {
    O.call(this)
  }
  w(Vf, O);
  Vf.prototype.T = ye;
  Vf.prototype.ba = 1;

  function Wf()
  {
    O.call(this)
  }
  w(Wf, O);
  Wf.prototype.T = {};
  Wf.prototype.ba = 1;

  function Xf()
  {
    O.call(this)
  }
  w(Xf, O);
  Xf.prototype.T = {};
  Xf.prototype.ba = 1;

  function Yf()
  {
    O.call(this)
  }
  w(Yf, O);
  Yf.prototype.T = {};
  Yf.prototype.ba = 1;

  function Zf(a)
  {
    function b(a)
    {
      this.content = a
    }
    b.prototype = a.prototype;
    return function(a)
    {
      return new b(String(a))
    }
  }
  var Tf = function(a)
  {
    function b(a)
    {
      this.content = a
    }
    b.prototype = a.prototype;
    return function(a, d)
    {
      var e = new b(String(a));
      void 0 !== d && (e.ba = d);
      return e
    }
  }(Sf);
  Zf(Uf);
  var $f = Zf(Vf);
  Zf(Wf);
  Zf(Xf);
  Zf(Yf);
  (function(a)
  {
    function b(a)
    {
      this.content = a
    }
    b.prototype = a.prototype;
    return function(a, d)
    {
      var e = String(a);
      if (!e) return "";
      e = new b(e);
      void 0 !== d && (e.ba = d);
      return e
    }
  })(Sf);

  function U(a)
  {
    null != a && a.T === xe ? (a = a.getContent(), a = String(a).replace(ag, "").replace(bg, "\x26lt;"), a = String(a).replace(cg, dg)) : a = la(String(a));
    return a
  }
  var eg = /['()]/g;

  function fg(a)
  {
    return "%" + a.charCodeAt(0).toString(16)
  }

  function gg(a)
  {
    null != a && a.T === ye ? a = String(a).replace(hg, ig) : a instanceof rd ? (a = a instanceof rd && a.constructor === rd && a.g === sd ? a.c : "type_error:SafeUrl", a = String(a).replace(hg, ig)) : a instanceof td ? (a = a instanceof td && a.constructor === td && a.g === ud ? a.c : "type_error:TrustedResourceUrl", a = String(a).replace(hg, ig)) : (a = String(a), a = jg.test(a) ? a.replace(hg, ig) : "#zSoyz");
    return a
  }
  var kg = {
    "\x00": "\x26#0;",
    "\t": "\x26#9;",
    "\n": "\x26#10;",
    "\x0B": "\x26#11;",
    "\f": "\x26#12;",
    "\r": "\x26#13;",
    " ": "\x26#32;",
    '"': "\x26quot;",
    "\x26": "\x26amp;",
    "'": "\x26#39;",
    "-": "\x26#45;",
    "/": "\x26#47;",
    "\x3c": "\x26lt;",
    "\x3d": "\x26#61;",
    "\x3e": "\x26gt;",
    "`": "\x26#96;",
    "\u0085": "\x26#133;",
    "\u00a0": "\x26#160;",
    "\u2028": "\x26#8232;",
    "\u2029": "\x26#8233;"
  };

  function dg(a)
  {
    return kg[a]
  }
  var lg = {
    "\x00": "%00",
    "\u0001": "%01",
    "\u0002": "%02",
    "\u0003": "%03",
    "\u0004": "%04",
    "\u0005": "%05",
    "\u0006": "%06",
    "\u0007": "%07",
    "\b": "%08",
    "\t": "%09",
    "\n": "%0A",
    "\x0B": "%0B",
    "\f": "%0C",
    "\r": "%0D",
    "\u000e": "%0E",
    "\u000f": "%0F",
    "\u0010": "%10",
    "\u0011": "%11",
    "\u0012": "%12",
    "\u0013": "%13",
    "\u0014": "%14",
    "\u0015": "%15",
    "\u0016": "%16",
    "\u0017": "%17",
    "\u0018": "%18",
    "\u0019": "%19",
    "\u001a": "%1A",
    "\u001b": "%1B",
    "\u001c": "%1C",
    "\u001d": "%1D",
    "\u001e": "%1E",
    "\u001f": "%1F",
    " ": "%20",
    '"': "%22",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "\x3c": "%3C",
    "\x3e": "%3E",
    "\\": "%5C",
    "{": "%7B",
    "}": "%7D",
    "\u007f": "%7F",
    "\u0085": "%C2%85",
    "\u00a0": "%C2%A0",
    "\u2028": "%E2%80%A8",
    "\u2029": "%E2%80%A9",
    "\uff01": "%EF%BC%81",
    "\uff03": "%EF%BC%83",
    "\uff04": "%EF%BC%84",
    "\uff06": "%EF%BC%86",
    "\uff07": "%EF%BC%87",
    "\uff08": "%EF%BC%88",
    "\uff09": "%EF%BC%89",
    "\uff0a": "%EF%BC%8A",
    "\uff0b": "%EF%BC%8B",
    "\uff0c": "%EF%BC%8C",
    "\uff0f": "%EF%BC%8F",
    "\uff1a": "%EF%BC%9A",
    "\uff1b": "%EF%BC%9B",
    "\uff1d": "%EF%BC%9D",
    "\uff1f": "%EF%BC%9F",
    "\uff20": "%EF%BC%A0",
    "\uff3b": "%EF%BC%BB",
    "\uff3d": "%EF%BC%BD"
  };

  function ig(a)
  {
    return lg[a]
  }
  var cg = /[\x00\x22\x27\x3c\x3e]/g,
    hg = /[\x00- \x22\x27-\x29\x3c\x3e\\\x7b\x7d\x7f\x85\xa0\u2028\u2029\uff01\uff03\uff04\uff06-\uff0c\uff0f\uff1a\uff1b\uff1d\uff1f\uff20\uff3b\uff3d]/g,
    jg = /^(?![^#?]*\/(?:\.|%2E){2}(?:[\/?#]|$))(?:(?:https?|mailto):|[^&:\/?#]*(?:[\/?#]|$))/i,
    ag = /<(?:!|\/?([a-zA-Z][a-zA-Z0-9:\-]*))(?:[^>'"]|"[^"]*"|'[^']*')*>/g,
    bg = /</g;

  function V(a)
  {
    google.maps.MVCObject.call(this);
    this.a = new google.maps.FusionTablesLayer(
    {
      suppressInfoWindows: !0
    });
    google.maps.event.addListener(this.a, "click", u(function(a)
    {
      var c;
      c = De(mg,
      {
        row: a.row
      }, void 0, new Cd(void 0));
      (new google.maps.InfoWindow(
      {
        content: c,
        position: a.latLng
      })).open(this.a.getMap())
    }, this));
    this.a.bindTo("map", this);
    this.setValues(a)
  }
  w(V, google.maps.MVCObject);
  V.prototype.b = function()
  {
    ng(this)
  };
  V.prototype.fillOpacity_changed = V.prototype.b;
  V.prototype.g = function()
  {
    ng(this)
  };
  V.prototype.strokeOpacity_changed = V.prototype.g;
  V.prototype.h = function()
  {
    og(this)
  };
  V.prototype.tableId_changed = V.prototype.h;
  V.prototype.c = function()
  {
    og(this)
  };
  V.prototype.airspace_changed = V.prototype.c;

  function og(a)
  {
    var b = {
      select: "geometry"
    };
    b.from = "" + a.get("tableId");
    var c = a.get("airspace");
    q(c) && 0 < c ? b.where = "floor_m \x3c\x3d " + Math.ceil(c) : 0 === c && (b.where = "floor_m \x3c 0");
    a.a.setOptions(
    {
      query: b
    })
  }

  function ng(a)
  {
    var b = [
    {
      polygonOptions:
      {
        fillOpacity: a.get("fillOpacity"),
        strokeOpacity: a.get("strokeOpacity")
      }
    }];
    a.a.setOptions(
    {
      styles: b
    })
  };

  function pg(a)
  {
    return [a >> 24 & 255, a >> 16 & 255, a >> 8 & 255, a & 255]
  }
  var qg = Array(256),
    rg, sg, tg;
  for (tg = 0; 256 > tg; ++tg)
  {
    rg = tg;
    for (sg = 0; 8 > sg; ++sg) rg = rg & 1 ? 3988292384 ^ rg >>> 1 : rg >>> 1;
    qg[tg] = 0 > rg ? 4294967296 + rg : rg
  }

  function ug(a, b)
  {
    var c = q(b) ? b : 4294967295,
      d, e = a.length;
    for (d = 0; d < e; ++d) c = qg[(c ^ a[d]) & 255] ^ c >>> 8;
    return c
  }

  function vg(a, b)
  {
    var c = ug(a),
      c = ug(b, c) ^ 4294967295;
    return String.fromCharCode.apply(null, [].concat(pg(b.length), a, b, pg(0 > c ? 4294967296 + c : c)))
  }

  function wg(a)
  {
    if (q(a.toDataURL))
    {
      var b = a.toDataURL();
      if ("data:," != b) return b
    }
    var c = a.getContext("2d").getImageData(0, 0, a.width, a.height);
    a = vg([73, 72, 68, 82], [].concat(pg(c.width), pg(c.height), [8, 6, 0, 0, 0]));
    var b = [q(void 0) ? void 0 : 0],
      d = Array.prototype.slice.call(c.data),
      e = c.height,
      c = 4 * c.width,
      f = Array(2 * e),
      h;
    for (h = 0; h < e; ++h) f[2 * h] = b, f[2 * h + 1] = d.slice(h * c, (h + 1) * c);
    b = Array.prototype.concat.apply([], f);
    d = Math.floor(b.length / 32768);
    c = b.length % 32768;
    0 === c && (--d, c = 0 === b.length ? 0 : 32768);
    e = Array(2 * d + 3);
    for (f =
      0; f < d; ++f) e[2 * f] = [0, 0, 128, 255, 127], e[2 * f + 1] = b.slice(32678 * f, 32768 * (f + 1));
    e[2 * d] = [1, c & 255, c >> 8, ~c & 255, ~c >> 8 & 255];
    e[2 * d + 1] = b.slice(32768 * d);
    var c = 1,
      f = 0,
      k = b.length;
    for (h = 0; h < k; ++h) c = (c + b[h]) % 65521, f = (f + c) % 65521;
    e[2 * d + 2] = pg(65536 * f + c);
    return "data:image/png;base64," + window.btoa("\u0089PNG\r\n\u001a\n" + a + vg([73, 68, 65, 84], [].concat([120, 1], Array.prototype.concat.apply([], e))) + vg([73, 69, 78, 68], []))
  };

  function xg(a, b)
  {
    var c = b ||
    {};
    c.draggable = !0;
    c.flat = !0;
    c.raiseOnDrag = !1;
    google.maps.Marker.call(this, c);
    this.a = !1;
    this.bindTo("icon", this, "iconOut");
    this.bindTo("iconOver", a);
    this.bindTo("shape", a);
    this.bindTo("zIndex", a);
    google.maps.event.addListener(this, "mouseout", u(this.b, this));
    google.maps.event.addListener(this, "mouseover", u(this.c, this));
    google.maps.event.addListener(this, "dblclick", u(a.Tb, a, this));
    google.maps.event.addListener(this, "dragstart", u(a.Wb, a, this))
  }
  w(xg, google.maps.Marker);
  xg.prototype.Z = function()
  {
    this.a || (this.unbindAll(), this.setMap(null), google.maps.event.clearInstanceListeners(this), this.a = !0)
  };
  xg.prototype.wa = function()
  {
    return this.a
  };
  xg.prototype.b = function()
  {
    this.bindTo("icon", this, "iconOut")
  };
  xg.prototype.c = function()
  {
    this.bindTo("icon", this, "iconOver")
  };

  function W(a, b)
  {
    google.maps.MVCObject.call(this);
    this.v = !1;
    this.b = -1;
    this.h = null;
    this.a = [];
    this.m = !1;
    this.c = a;
    this.c.bindTo("clickable", this);
    this.c.bindTo("fillColor", this);
    this.c.bindTo("fillOpacity", this);
    this.c.bindTo("geodesic", this);
    this.c.bindTo("map", this);
    this.c.bindTo("strokeColor", this);
    this.c.bindTo("strokeOpacity", this);
    this.c.bindTo("strokeWeight", this);
    this.c.bindTo("zIndex", this);
    this.g = null;
    this.set("moveIconOut",
    {
      anchor: new google.maps.Point(15.5, 15.5),
      size: new google.maps.Size(31,
        31),
      url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAABmJLR0QA/wD/AP+gvaeTAAACu0lEQVRIicXXT2hUVxQG8N9kXpDJRDQVZiwlVtctGFoKggo22BYEg5tQmIVNKlGo0FLaQnGhiLgq3VgIBSGLVHAjbawIbUNJCYZ0MZkJiBuxne78kzaYgpFknEwXM0PHSeZPxpD54G7ePed837v33Pu+R/MI+ulF8AI1msPrdN/np7fo3mzu0A1OLzM7xmmENpP8pTnG8iTn+BFdzRRpq3ywjT2dxBCuljTMge28CtvpHuZgDY5wJ7Ft7KlLnuPJHYaTXPyMNxGtCOl4j76AHATk3uUoOirioh+yd5Izt/lmC4s1BP6vdJKzOVJLzGQYGSURI47wAD0LTC2WjQWmBuhBOEZ8lESGkSVmcqQmOavGSj6HIXqWmMmTzJPMkp5nYrBwtOLYucaID9I7z0SWdCl3iZmhgrCGEc0wUkaeGudzq5e2EpGbfLJMqpSbYcTqrauNKySypNdBvEpAlvQoiXURQ4z4PBNF4shaMXmO1BIwz2/FXlk3wsd5uxpxkTxZIz9SzG+s0crQMVBoklitoDrkECvWqbtlIXR9zZG7fLvAtDpL1gB5/F9+/4vvRulXuAmfu4rDe3nlGkMP+H6Z2TzJxQ0iX2S6dFz/5vrPfLqP3QhC/fRe4osdvNzOs1LWU7IdHMPDItFRnKtDBudD3CgjH4vQXprMEvzD/Y/5qqVvXh7Ykj1fC5ve7ZVo2Tlv7Q23GXf7KjNRRHQ/hwNyASuHSIzzUQMCIjc5+Q4ftLMSkDvIYVW+amvuxxCvvc/J0uQKbTvY9Yg/ZwuOZCs6K0Z0kDdOcGoLkTbyCmp3PuRWigd1hBcEtczJdBLLcHWaC9U83D0ul8xCnuQ9Lqvi4X7lyz+40lDjNehe+0pWKUt6mL4aJau612bRNccPRd9+3Ub59gbxeJrxLMEUv+Bxk3WaQyv/1diAv9T/AHJoJzXJQF33AAAAAElFTkSuQmCC"
    });
    this.set("iconOver",
    {
      anchor: new google.maps.Point(15.5, 15.5),
      size: new google.maps.Size(31, 31),
      url: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAfCAYAAAAfrhY5AAAABmJLR0QA/wD/AP+gvaeTAAACOElEQVRIic3XvU+TURQG8J+F6iJaI25KomjiYOwgwU03BhMWTMRENzEpCYaPuIlOjMY/gJ0YWcSIMWHS3UQkqCQGFnEyKFAoCLSvQ1tTSukHNNQnOct5zz3Pvfc993ywdzSeYRGN+/CxNxzl8RSpCE8Omrv+PgsBQRe/ED5I8tufWQ4IvhJHZ1W81jEcIoaG3WzamAoIstLGVBGXDSFidQyXJA8Re0fyKWuXeI7WPJOWV6zkko+xgpY8u9bzjDwiMUEynD5QSTQMkggIkmyNE+9gNkwPIs2MLrCZYC0rC2w2M4pImJ4OZseJJ9kKCAZJKHCThwqxX2Bkhs4QdVndPBvXWZjjmRx9DpLnGHjPydMczipTJC/y4ht3yjk5XH2z/WpTfSzjSol1l7tZSpHKrh1PB2T+ryuOm8xWSFxwAx3MVUQMYXq+86ePJUR3Mbuxiz7azeI8G0d4UDE5Imf5UYQYPhT5Fs2sj1RK3JKJ3t4SdsXIoTfjJ/8Z7kAYndf4NEr8N5vo3yd5/xJbE6x2MC2dCbel4kgDA3f5+ZF4NkrXWK8G+RrrWZ8zLPeweIIhnNLE0mTO0yhC3p4hKyXtu5FnZZJUUzqQHa/Rybf1ATX554Vw4NGej5q989pmuNzc3psuDuXm9uh+c/uOqlbmBqKVVLX/rp4fWCezAyFib0kOFenhxvJ6uJdFeriHrL4ut4erafdaJjqnM337l3RA3aqW43JQ35WZWO7VYGL5N6sdq8GsRhWm1L+mJ24Us5n1HwAAAABJRU5ErkJggg\x3d\x3d"
    });
    this.set("shape",
    {
      coords: [15.5, 15.5, 15.5],
      type: "circle"
    });
    this.o = Array(64);
    var c;
    for (c = 0; 64 > c; ++c) this.o[c] = yg(2 * Math.PI * c / 64);
    this.setValues(b)
  }
  w(W, google.maps.MVCObject);

  function zg(a, b)
  {
    var c = a.getPath();
    if (null != c)
    {
      var d = a.get("editable");
      c.push(b);
      var e = 2 * c.getLength();
      a.a[e - 3].setPosition(google.maps.geometry.spherical.interpolate(a.getPosition(c, (e - 4) / 2), b, .5));
      d && a.a[e - 3].bindTo("map", a);
      var f;
      f = new xg(a,
      {
        position: b
      });
      d && f.bindTo("map", a);
      Ag(a, f, 0);
      a.a.push(f);
      f = new xg(a,
      {
        position: google.maps.geometry.spherical.interpolate(b, a.getPosition(c, 0), .5)
      });
      a.a.push(f);
      Ag(a, f, 1);
      Bg(a, c, e - 3);
      Cg(a, !0)
    }
  }
  W.prototype.Z = function()
  {
    this.v || (this.unbindAll(), this.set("map", null), x(this.a, hd), google.maps.event.clearInstanceListeners(this))
  };
  W.prototype.j = function()
  {
    var a = this.getPath();
    if (null != a)
    {
      var b = this.get("editable"),
        c = 2 * a.getLength();
      x(this.a, function(a, e)
      {
        b && (e != c - 1 || this.c instanceof google.maps.Polygon) ? a.bindTo("map", this) : (a.unbind("map"), a.setMap(null))
      }, this)
    }
  };
  W.prototype.editable_changed = W.prototype.j;

  function Dg(a)
  {
    var b = new google.maps.LatLngBounds;
    a = a.getPath();
    null != a && x(a.getArray(), b.extend, b);
    return b
  }
  W.prototype.getPath = function()
  {
    return this.c.getPath()
  };
  W.prototype.getPosition = function(a, b)
  {
    return a.getAt(b)
  };
  W.prototype.B = function()
  {
    var a = this.get("map");
    null === a ? (this.unbind("projection"), this.set("projection", null)) : this.bindTo("projection", a)
  };
  W.prototype.map_changed = W.prototype.B;
  g = W.prototype;
  g.Ub = function(a)
  {
    var b = this.getPath();
    if (0 == this.b % 2)
    {
      var c = b.getLength(),
        d = 2 * c;
      b.setAt(this.b / 2, a.latLng);
      this.a[(this.b + d - 1) % d].setPosition(google.maps.geometry.spherical.interpolate(this.getPosition(b, (this.b + d - 2) / 2 % c), a.latLng, .5));
      Bg(this, b, (this.b + d - 1) % d);
      this.a[(this.b + 1) % d].setPosition(google.maps.geometry.spherical.interpolate(a.latLng, this.getPosition(b, (this.b + 2) / 2 % c), .5));
      Bg(this, b, (this.b + 1) % d)
    }
    else b.setAt((this.b + 1) / 2, a.latLng)
  };
  g.Vb = function(a)
  {
    google.maps.event.removeListener(this.h);
    this.h = null;
    if (1 == this.b % 2)
    {
      var b;
      b = this.a[this.b];
      Ag(this, b, 0);
      var c = this.getPath();
      if (null == c) return;
      var d = c.getLength();
      b = new xg(this,
      {
        position: google.maps.geometry.spherical.interpolate(this.getPosition(c, (this.b - 1) / 2), a.latLng, .5)
      });
      Ag(this, b, 1);
      b.bindTo("map", this);
      Fa(this.a, this.b, 0, b);
      b = new xg(this,
      {
        position: google.maps.geometry.spherical.interpolate(a.latLng, this.getPosition(c, (this.b + 3) / 2 % d), .5)
      });
      Ag(this, b, 1);
      b.bindTo("map", this);
      Fa(this.a, this.b + 2, 0, b);
      Bg(this, c, this.b);
      Bg(this, c, this.b + 2)
    }
    this.b = -1
  };
  g.Wb = function(a)
  {
    var b = this.getPath();
    null != b && (this.b = ya(this.a, a), 1 == this.b % 2 && b.insertAt((this.b + 1) / 2, a.getPosition()), this.h = google.maps.event.addListener(a, "drag", u(this.Ub, this)), google.maps.event.addListenerOnce(a, "dragend", u(this.Vb, this)), Cg(this, !0))
  };
  g.Tb = function(a)
  {
    a = ya(this.a, a);
    if (0 == a % 2)
    {
      var b = this.getPath(),
        c = b.getLength();
      if (this.c instanceof google.maps.Polygon)
      {
        if (4 > c) return
      }
      else if (3 > c) return;
      var d = 2 * c;
      0 === a ? (this.a[d - 1].setPosition(google.maps.geometry.spherical.interpolate(this.getPosition(b, c - 1), this.getPosition(b, 1), .5)), c = Fa(this.a, 0, 2), b.removeAt(0), Bg(this, b, 1), Bg(this, b, d - 3)) : (this.a[a + 1].setPosition(google.maps.geometry.spherical.interpolate(this.getPosition(b, (a - 2) / 2), this.getPosition(b, (a + 2) / 2 % c), .5)), c = Fa(this.a, a - 1, 2), b.removeAt(a /
        2), Bg(this, b, a - 1), Bg(this, b, (a + 1) % (d - 2)));
      x(c, hd)
    }
  };
  g.hc = function()
  {
    this.g = this.get("projection");
    var a = this.getPath();
    if (null !== this.g && null != a)
    {
      var b = 2 * a.getLength(),
        c;
      for (c = 1; c < b; c += 2) Bg(this, a, c)
    }
  };
  W.prototype.projection_changed = W.prototype.hc;
  W.prototype.setAt = function(a, b)
  {
    var c = this.getPath(),
      d = c.getLength(),
      e = 2 * d;
    c.setAt(a, b);
    this.a[(2 * a + e - 1) % e].setPosition(google.maps.geometry.spherical.interpolate(this.getPosition(c, (2 * a + e - 2) / 2 % d), b, .5));
    this.a[2 * a].setPosition(b);
    this.a[(2 * a + 1) % e].setPosition(google.maps.geometry.spherical.interpolate(b, this.getPosition(c, (a + 1) % d), .5))
  };

  function Cg(a, b)
  {
    b && !a.m && google.maps.event.trigger(a, "first_modified");
    a.m = b
  }
  W.prototype.setPath = function(a)
  {
    this.c.setPath(a);
    x(this.a, hd);
    a = this.getPath();
    if (null != a)
    {
      var b = a.getLength(),
        c = 2 * b,
        d, e, f;
      this.a = Array(c);
      for (d = 0; d < c; ++d) 0 == d % 2 ? f = this.getPosition(a, d / 2) : f = google.maps.geometry.spherical.interpolate(this.getPosition(a, (d - 1) / 2), this.getPosition(a, (d + 1) / 2 % b), .5), e = new xg(this,
      {
        position: f
      }), this.a[d] = e, 0 === d % 2 ? Ag(this, e, 0) : (Ag(this, e, 1), Bg(this, a, d));
      this.j()
    }
    else this.a = []
  };

  function Ag(a, b, c)
  {
    0 == c ? b.bindTo("iconOut", a, "moveIconOut") : b.unbind("iconOut")
  }

  function Eg(a, b)
  {
    var c = 0;
    x(a.a, function(a, e)
    {
      0 === e % 2 || null !== this.b && this.b == e ? (a.getTitle() != b[c] && a.setTitle(b[c]), c += 1) : "" !== a.getTitle() && a.setTitle("")
    }, a)
  }

  function Bg(a, b, c)
  {
    if (null != a.g)
    {
      var d = b.getLength(),
        e = a.g.fromLatLngToPoint(a.getPosition(b, (c - 1) / 2));
      b = a.g.fromLatLngToPoint(a.getPosition(b, (c + 1) / 2 % d));
      e = a.o[Math.floor(64 * (Math.atan2(b.y - e.y, b.x - e.x) + Math.PI) / (2 * Math.PI) + .5) % 64];
      a.a[c].get("iconOut") != e && a.a[c].set("iconOut", e)
    }
  }

  function yg(a)
  {
    var b = Kd("canvas",
      {
        height: 31,
        width: 31
      }),
      c = b.getContext("2d"),
      d = [new J(-1, 0), new J(1, 1), new J(.5, 0), new J(1, -1)],
      e = Math.cos(a),
      f = Math.sin(a);
    c.beginPath();
    x(d, function(a, b)
    {
      var d = 15.5 + 7 * (a.x * e - a.y * f),
        n = 15.5 + 7 * (a.x * f + a.y * e);
      0 === b ? c.moveTo(d, n) : c.lineTo(d, n)
    });
    c.closePath();
    c.fillStyle = "#ff0000"; // fleche
    c.fill();
    return {
      anchor: new google.maps.Point(16, 16),
      size: new google.maps.Size(31, 31),
      url: wg(b)
    }
  }

  function Fg(a)
  {
    W.call(this, new google.maps.Polyline, a)
  }
  w(Fg, W);

  function Gg(a, b)
  {
    M.call(this);
    var c = this.a = a,
      c = da(c) && 1 == c.nodeType ? this.a : this.a ? this.a.body : null;
    this.j = !!c && af(c);
    this.b = L(this.a, Rc ? "DOMMouseScroll" : "mousewheel", this, b)
  }
  w(Gg, M);
  Gg.prototype.handleEvent = function(a)
  {
    var b = 0,
      c = 0,
      d = 0;
    a = a.c;
    if ("mousewheel" == a.type)
    {
      c = 1;
      if (H || Sc && (Uc || I("532.0"))) c = 40;
      d = Hg(-a.wheelDelta, c);
      q(a.wheelDeltaX) ? (b = Hg(-a.wheelDeltaX, c), c = Hg(-a.wheelDeltaY, c)) : c = d
    }
    else d = a.detail, 100 < d ? d = 3 : -100 > d && (d = -3), q(a.axis) && a.axis === a.HORIZONTAL_AXIS ? b = d : c = d;
    "number" == typeof this.c && (b = Math.min(Math.max(b, -this.c), this.c));
    "number" == typeof this.h && (c = Math.min(Math.max(c, -this.h), this.h));
    this.j && (b = -b);
    b = new Ig(d, a, b, c);
    N(this, b)
  };

  function Hg(a, b)
  {
    return Sc && (Tc || Vc) && 0 != a % b ? a : a / b
  }
  Gg.prototype.C = function()
  {
    Gg.A.C.call(this);
    ne(this.b);
    this.b = null
  };

  function Ig(a, b, c, d)
  {
    ld.call(this, b);
    this.type = "mousewheel";
    this.detail = a;
    this.m = c;
    this.g = d
  }
  w(Ig, ld);
  var Jg = function()
  {
    var a = [
    {
      innerHTML: "Skyways",
      t: "all",
      jb: "skyways"
    }];
    x(["January", "April", "July", "October"], function(b)
    {
      x(["04", "07", "10"], function(c)
      {
        a.push(
        {
          innerHTML: b + "\x3cbr\x3esunrise +" + parseInt(c, 10) + "h",
          t: b.substr(0, 3) + "_" + c,
          jb: "thermals"
        })
      })
    });
    return a
  }();

  function X(a, b)
  {
    google.maps.MVCObject.call(this);
    this.O = a;
    this.a = K("control_airspace", a);
    L(this.a, "click", this.Cb, !1, this);
    L(new Gg(this.a), "mousewheel", this.Db, !1, this);
    L(this.a, "mousemove", v(this.Ha, this.a));
    this.j = K("control_distance", a);
    this.b = K("control_duration", a);
    L(this.b, "click", this.Kb, !1, this);
    L(new Gg(this.b), "mousewheel", this.Lb, !1, this);
    L(this.b, "mousemove", v(this.Ha, this.b));
    this.F = K("control_collapse", a);
    this.o = K("control_expand", a);
    this.v = K("control_multiplier", a);
    this.B = K("control_points",
      a);
    this.c = K("control_speed", a);
    L(this.c, "click", this.bc, !1, this);
    L(new Gg(this.c), "mousewheel", this.cc, !1, this);
    L(this.c, "mousemove", v(this.Ha, this.c));
    this.g = K("control_thermals", a);
    L(this.g, "click", this.dc, !1, this);
    L(new Gg(this.g), "mousewheel", this.ec, !1, this);
    L(this.g, "mousemove", v(this.Ha, this.g));
    this.m = -1;
    x([this.j, this.v, this.B], u(function(a)
    {
      L(a, "click", this.ra, !1, this)
    }, this));
    L(this.F, "click", v(this.h, 0), !1, this);
    L(this.o, "click", v(this.h, 1), !1, this);
    /Android|iPad|iPhone|iPod/.test(Mc) ?
      this.h(0) : this.h(1);
    var c = b ||
    {};
    A(c, "airspace", 0);
    A(c, "altitudeUnit", Db);
    A(c, "distance", 0);
    A(c, "distanceUnit", Bb);
    A(c, "constraint", new Ob(null, 2E4 / 3600));
    A(c, "flownDistance", 0);
    A(c, "multiplier", 1);
    A(c, "points", 0);
    A(c, "speedUnit", Cb);
    A(c, "thermals", -1);
    this.setValues(c)
  }
  w(X, google.maps.MVCObject);
  X.prototype.sa = function()
  {
    Kg(this)
  };
  X.prototype.airspace_changed = X.prototype.sa;
  X.prototype.H = function()
  {
    Kg(this)
  };
  X.prototype.altitudeUnit_changed = X.prototype.H;
  X.prototype.K = function()
  {
    Lg(this)
  };
  X.prototype.constraint_changed = X.prototype.K;
  X.prototype.M = function()
  {
    Mg(this)
  };
  X.prototype.distance_changed = X.prototype.M;
  X.prototype.L = function()
  {
    Mg(this)
  };
  X.prototype.distanceUnit_changed = X.prototype.L;
  X.prototype.X = function()
  {
    Lg(this)
  };
  X.prototype.flownDistance_changed = X.prototype.X;
  X.prototype.Y = function()
  {
    var a = this.get("multiplier");
    Qd(this.v.children[1], "\u00d7" + a.toString())
  };
  X.prototype.multiplier_changed = X.prototype.Y;
  X.prototype.wa = function()
  {
    var a = this.get("name");
    Qd(this.j.children[0], a)
  };
  X.prototype.name_changed = X.prototype.wa;

  function Ng(a, b, c)
  {
    var d;
    d = a.get("altitudeUnit") === Ab ? .3048 * (c ? 100 : 500) : c ? 50 : 250;
    c = a.get("airspace");
    b = Og(c, b, d);
    b = Math.min(Math.max(b, 0), 9999);
    b != c && a.set("airspace", b)
  }

  function Pg(a, b, c)
  {
    c = 60 * (c ? 5 : 15);
    var d = a.get("constraint"),
      e;
    null === d.a ? (e = a.get("flownDistance"), e = null === d.a ? e / d.b : d.a) : e = d.a;
    e = Og(e, b, c);
    e < c && (e = c);
    e != d.a && (d.a = e, d.b = null, a.notify("constraint"))
  }

  function Qg(a, b, c)
  {
    c = a.get("speedUnit") === Fb ? (c ? 160.9344 : 1609.344) / 3600 : (c ? 100 : 1E3) / 3600;
    var d = a.get("constraint"),
      e;
    null === d.b ? (e = a.get("flownDistance"), e = null === d.b ? e / d.a : d.b) : e = d.b;
    e = Og(e, b, c);
    e < c && (e = c);
    e != d.b && (d.a = null, d.b = e, a.notify("constraint"))
  }

  function Rg(a, b)
  {
    var c = a.get("thermals");
    a.set("thermals", Qa(c + 1 + b, Jg.length + 1) - 1)
  }
  g = X.prototype;
  g.Cb = function(a)
  {
    a = Ve(a, this.a).x / Ye(this.a).width;
    Ng(this, .5 <= a, !1)
  };
  g.Db = function(a)
  {
    a.b();
    0 !== a.g ? Ng(this, 0 > a.g, !1) : 0 !== a.m && Ng(this, 0 < a.m, !0)
  };
  g.Ha = function(a, b)
  {
    var c = Ve(b, a).x / Ye(a).width;
    if (t("cursor")) Oe(a, .5 > c ? "s-resize" : "n-resize", "cursor");
    else
      for (var d in "cursor") Oe(a, "cursor" [d], d)
  };
  g.Kb = function(a)
  {
    a = Ve(a, this.b).x / Ye(this.b).width;
    Pg(this, .5 <= a, !1)
  };
  g.Lb = function(a)
  {
    a.b();
    0 !== a.g ? Pg(this, 0 > a.g, !1) : 0 !== a.m && Pg(this, 0 < a.m, !0)
  };
  g.bc = function(a)
  {
    a = Ve(a, this.c).x / Ye(this.c).width;
    Qg(this, .5 <= a, !1)
  };
  g.cc = function(a)
  {
    a.b();
    0 !== a.g ? Qg(this, 0 > a.g, !1) : 0 !== a.m && Qg(this, 0 < a.m, !0)
  };
  g.dc = function(a)
  {
    a = Ve(a, this.g).x / Ye(this.g).width;
    Rg(this, .5 <= a ? 1 : -1)
  };
  g.ec = function(a)
  {
    a.b();
    0 !== a.g && Rg(this, 0 < a.g ? -1 : 1)
  };
  g.ic = function()
  {
    var a = this.get("points").toFixed(1).split(".", 2),
      b = this.B.children[1].children;
    Qd(b[0], a[0]);
    Qd(b[1], "." + a[1])
  };
  X.prototype.points_changed = X.prototype.ic;
  X.prototype.h = function(a, b)
  {
    q(b) && b.h();
    if (this.m != a)
    {
      var c = 1 == a,
        d = this.O.children,
        d = Ga(d, 1, d.length - 1);
      x(d, function(a)
      {
        P(a, c)
      });
      P(this.o, !c);
      this.m = a
    }
  };
  X.prototype.fa = function()
  {
    Lg(this)
  };
  X.prototype.speedUnit_changed = X.prototype.fa;
  X.prototype.Ka = function()
  {
    Sg(this)
  };
  X.prototype.thermals_changed = X.prototype.Ka;
  X.prototype.ra = function(a)
  {
    a.h();
    0 == this.m ? this.h(1) : this.h(0)
  };

  function Kg(a)
  {
    var b = a.get("airspace");
    1E-4 < b ? (b = a.get("altitudeUnit")(b), b = b[0] + b[1]) : b = "OFF";
    Qd(a.a.children[1], b)
  }

  function Mg(a)
  {
    var b = a.get("distance"),
      c = a.get("distanceUnit");
    q(b) && q(c) && (b = c(b)[0].split(".", 2), a = a.j.children[1].children, Qd(a[0], b[0]), Qd(a[1], "." + b[1]))
  }

  function Lg(a)
  {
    var b = a.get("constraint"),
      c = a.get("flownDistance"),
      d = a.get("speedUnit");
    if (q(b) && q(c) && q(d))
    {
      var e = null === b.a ? c / b.b : b.a;
      Qd(a.b.children[1], Math.floor(e / 3600) + ":" + ua(Math.floor(e / 60 % 60), 2));
      b = d(null === b.b ? c / b.a : b.b)[0].split(".", 2);
      a = a.c.children[1].children;
      Qd(a[0], b[0]);
      Qd(a[1], "." + b[1])
    }
  }

  function Sg(a)
  {
    var b = a.get("thermals"),
      c;
    0 > b ? (c = "OFF", b = null) : (c = Jg[b].innerHTML, b = new google.maps.ImageMapType(
    {
      getTileUrl: v(function(a, b, c)
      {
        var h = new B("https://thermal.kk7.ch/php/tile.php"),
          k = h.b;
        D(k, "src", "meteo-parapente.com");
        D(k, "t", a.t);
        D(k, "typ", a.jb);
        a = 1 << c;
        D(k, "x", Qa(b.x, a));
        D(k, "y", Qa(a - b.y - 1, a));
        D(k, "z", c);
        return h.toString()
      }, Jg[b]),
      opacity: .5,
      tileSize: new google.maps.Size(256, 256)
    }));
    a.g.children[1].innerHTML = c;
    a.set("thermalLayer", b)
  }

  function Og(a, b, c)
  {
    var d = Math.floor(a / c);
    a = a / c % 1;
    return b ? 1E-4 > 1 - a ? c * (d + 2) : c * (d + 1) : 1E-4 > a ? c * (d - 1) : c * d
  };

  function Tg(a, b)
  {
    for (var c = a.length, d = Array(c), e = 0; e < c; ++e) d[e] = b.call(void 0, a[e], a[(e + 1) % c], e, a);
    return d
  };

  function Ug(a)
  {
    if (3 > a.length) return 0;
    a = Tg(a, function(a, c)
    {
      return new google.maps.Point(a.x - c.x, a.y - c.y)
    });
    a = Tg(a, function(a, c)
    {
      return a.x * c.y - a.y * c.x
    });
    a = Aa(a, function(a, c)
    {
      return {
        min: Math.min(a.min, c),
        max: Math.max(a.max, c)
      }
    },
    {
      min: a[0],
      max: a[0]
    });
    return 0 > a.max ? -1 : 0 < a.min ? 1 : 0
  }

  function Vg(a)
  {
    var b = Ug(a);
    if (0 == b) return [];
    var c = new google.maps.Point(a[1].x - a[0].x, a[1].y - a[0].y),
      d = b * Math.atan2(c.y, c.x),
      e, f, h, c = Math.sqrt(c.x * c.x + c.y * c.y),
      k = Array(49);
    for (f = 28; 44 > f; ++f) e = c * f / 28, h = c * (72 - f) / 28, e = (h * h + c * c - e * e) / (2 * c), h = Math.sqrt(h * h - e * e), k[f - 28] = new google.maps.Point(a[0].x + e * Math.cos(d) - h * Math.sin(d), a[0].y + b * (e * Math.sin(d) + h * Math.cos(d)));
    for (f = 28; 44 > f; ++f) e = c * (72 - f) / f, h = 28 * c / f, e = (h * h + c * c - e * e) / (2 * c), h = Math.sqrt(h * h - e * e), k[16 + f - 28] = new google.maps.Point(a[0].x + e * Math.cos(d) - h * Math.sin(d),
      a[0].y + b * (e * Math.sin(d) + h * Math.cos(d)));
    for (f = 44; 28 <= f; --f) e = 28 * c / f, h = c * (72 - f) / f, e = (h * h + c * c - e * e) / (2 * c), h = Math.sqrt(h * h - e * e), k[76 - f] = new google.maps.Point(a[0].x + e * Math.cos(d) - h * Math.sin(d), a[0].y + b * (e * Math.sin(d) + h * Math.cos(d)));
    return k
  };

  function Wg(a)
  {
    google.maps.MVCObject.call(this);
    this.b = 0;
    this.a = [null, null, null];
    this.g = Array(3);
    var b, c;
    for (b = 0; 3 > b; ++b) c = new google.maps.Polygon(
    {
      clickable: !1
    }), c.bindTo("fillColor", this, "fillColor" + (b + 1)), c.bindTo("fillOpacity", this), c.bindTo("map", this), c.bindTo("strokeColor", this, "strokeColor" + (b + 1)), c.bindTo("strokeOpacity", this), c.bindTo("strokeWeight", this), c.bindTo("zIndex", this), this.g[b] = c;
    this.c = !1;
    this.setValues(a)
  }
  w(Wg, google.maps.MVCObject);
  Wg.prototype.h = function()
  {
    var a = this.get("map");
    null != a ? this.bindTo("projection", a) : this.unbind("projection")
  };
  Wg.prototype.map_changed = Wg.prototype.h;
  Wg.prototype.j = function()
  {
    Xg(this)
  };
  Wg.prototype.projection_changed = Wg.prototype.j;
  Wg.prototype.setAt = function(a, b)
  {
    null !== this.a[a] && this.a[a].equals(b) || (this.a[a] = b, Xg(this))
  };

  function Xg(a)
  {
    if (a.b) a.c = !0;
    else
    {
      a.c = !1;
      var b = a.get("map");
      if (null != b)
      {
        var c = b.getProjection();
        null != c && (b = z(a.a, function(a)
        {
          return c.fromLatLngToPoint(a)
        }), x([Vg([b[0], b[1], b[2]]), Vg([b[1], b[2], b[0]]), Vg([b[2], b[0], b[1]])], u(function(a, b)
        {
          this.g[b].setPath(z(a, function(a)
          {
            return c.fromPointToLatLng(a)
          }))
        }, a)))
      }
    }
  };

  function zc(a, b, c)
  {
    var d;
    d = google.maps.geometry.spherical.computeDistanceBetween(a, c, 6371E3);
    b = google.maps.geometry.spherical.computeHeading(a, b);
    a = google.maps.geometry.spherical.computeHeading(a, c);
    return 6371E3 * Math.asin(Math.sin(d / 6371E3) * Math.sin(Math.PI * (a - b) / 180))
  };

  function Y(a)
  {
    google.maps.MVCObject.call(this);
    this.a = new google.maps.Polygon(
    {
      clickable: !1
    });
    this.a.bindTo("fillColor", this);
    this.a.bindTo("fillOpacity", this);
    this.a.bindTo("map", this);
    this.a.bindTo("strokeColor", this);
    this.a.bindTo("strokeOpacity", this);
    this.a.bindTo("strokeWeight", this);
    this.a.bindTo("zIndex", this);
    this.setValues(a)
  }
  w(Y, google.maps.MVCObject);
  Y.prototype.b = function()
  {
    Yg(this)
  };
  Y.prototype.center_changed = Y.prototype.b;
  Y.prototype.getCenter = function()
  {
    return this.get("center")
  };
  Y.prototype.c = function()
  {
    Yg(this)
  };
  Y.prototype.heading_changed = Y.prototype.c;
  Y.prototype.g = function()
  {
    Yg(this)
  };
  Y.prototype.radius_changed = Y.prototype.g;

  function Yg(a)
  {
    var b = a.get("heading") || 0,
      c = a.getCenter(),
      d = a.get("radius") || 0;
    if (null != c)
    {
      for (var e = Array(34), f = 0; 32 >= f; ++f) e[f] = google.maps.geometry.spherical.computeOffset(c, d, b + 60 * (f / 32 - .5), 6371E3);
      e[33] = c;
      a.a.setPath(e)
    }
  };

  function Zg()
  {
    return Tf('\x3cdiv\x3e\x3cdiv\x3eXC Planner 2.0-mp\x3c/div\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Original version') + ' \x26copy; Tom Payne \x26lt;\x3ca href\x3d"mailto:twpayne@gmail.com"\x3etwpayne@gmail.com\x3c/a\x3e\x26gt;, 2009-2015\x3c/div\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Heavily hacked to work in Meteo-Parapente, with authorization from Tom. Thank you!') + '\x3c/div\x3e\x3c/div\x3e')
    /* return Tf('\x3cdiv\x3e\x3cdiv\x3eXC Planner version 2.0-mp\x3c/div\x3e\x3cdiv\x3eCopyright \x26copy; Tom Payne \x26lt;\x3ca href\x3d"mailto:twpayne@gmail.com"\x3etwpayne@gmail.com\x3c/a\x3e\x26gt;, 2009-2015\x3c/div\x3e\x3cdiv\x3eCopyright \x26copy; Meteo-Parapente, 2019\x3c/div\x3e\x3cdiv\x3eThank you Tom for letting us include XCPlanner in Meteo-Parapente!\x3c/div\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3eAirspace data\x3c/div\x3e\x3cdiv\x3eCourtesy of \x3ca href\x3d"http://www.openaip.net/"\x3eopenAIP.net\x3c/a\x3e\x3c/div\x3e\x3cdiv\x3eVisit \x3ca href\x3d"http://www.openaip.net/"\x3eopenAIP.net\x3c/a\x3e and contribute to better aviation data, free for everyone to use and share.\x3c/div\x3e\x3cdiv\x3eCourtesy of \x3ca href\x3d"http://soaringweb.org/Airspace/" target\x3d"_blank"\x3eWorldwide Soaring Turnpoint Exchange\x3c/a\x3e.\x3c/div\x3e\x3cdiv\x3eAll data and information contained in any of the data files are provided without guarantee as to their completeness or correctness.   Any conclusions drawn from these data and information are the sole responsibility of the user.\x3c/div\x3e\x3cdiv\x3eThis information may not be accurate or current and is not valid for navigation or flight planning.   No warranty of fitness for any purpose is made or implied.   Always consult the official publications for current and correct information.   This service is provided free of charge with no warrantees, expressed or implied.\x3c/div\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3eThermal data\x3c/div\x3e\x3cdiv\x3eCourtesy of \x3ca href\x3d"https://thermal.kk7.ch/" target\x3d"_blank"\x3eParaglidingNet\x3c/a\x3e.\x3c/a\x3e\x3cdiv\x3eAll ParaglidingNet Thermal Maps are licensed under a Creative Commons Attribution-NonCommercial-ShareAlike 3.0 Unported License by Michael von K\u00e4nel (info ...at... kk7. ch).\x3c/div\x3e\x3c/div\x3e') */
  }

  function mg(a)
  {
    return Tf("\x3cdiv style\x3d'width: 250px'\x3e\x3cb\x3eClass:\x3c/b\x3e " + T(a.row["class"].value) + "\x3cbr\x3e\x3cb\x3eName:\x3c/b\x3e " + T(a.row.name.value) + "\x3cbr\x3e\x3cb\x3eFloor:\x3c/b\x3e " + T(a.row.floor.value) + "\x3cbr\x3e\x3cb\x3eCeiling:\x3c/b\x3e " + T(a.row.ceiling.value) + "\x3cbr\x3e\x3cb\x3eCountry:\x3c/b\x3e " + T(a.row.country.value) + "\x3cbr\x3e\x3c/div\x3e")
  }

  function $g()
  {
    return Tf('\x3cdiv class\x3d"control"\x3e\x3cdiv class\x3d"control_distance"\x3e\x3cdiv\x3e\x3c/div\x3e\x3cdiv\x3e\x3cspan class\x3d"large"\x3e\x3c/span\x3e\x3cspan class\x3d"large secondary"\x3e\x3c/span\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_multiplier"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Multiplier') + '\x3c/div\x3e\x3cdiv class\x3d"large"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_points"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Points') + '\x3c/div\x3e\x3cdiv\x3e\x3cspan class\x3d"large"\x3e\x3c/span\x3e\x3cspan class\x3d"large secondary"\x3e\x3c/span\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_duration"\x3e\x3cdiv\x3e\x3cspan\x3e' + $pgettext('xc planner', 'Duration') + '\x3c/span\x3e\x3cdiv class\x3d"decrement"\x3e\x3cimg alt\x3d"Reduce duration" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAE0lEQVQImWP438DQAEP7kNj/GwCK4wo9HA2mvgAAAABJRU5ErkJggg\x3d\x3d" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3cdiv class\x3d"increment"\x3e\x3cimg alt\x3d"Increase duration" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAGElEQVQImWP438DQ0MDQAUb7YAygyP8GAIyjCl0WJTcvAAAAAElFTkSuQmCC" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"large"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_speed"\x3e\x3cdiv\x3e\x3cspan\x3e' + $pgettext('xc planner', 'Speed') + '\x3c/span\x3e\x3cdiv class\x3d"decrement"\x3e\x3cimg alt\x3d"Reduce speed" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAE0lEQVQImWP438DQAEP7kNj/GwCK4wo9HA2mvgAAAABJRU5ErkJggg\x3d\x3d" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3cdiv class\x3d"increment"\x3e\x3cimg alt\x3d"Increase speed" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAGElEQVQImWP438DQ0MDQAUb7YAygyP8GAIyjCl0WJTcvAAAAAElFTkSuQmCC" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv\x3e\x3cspan class\x3d"large"\x3e\x3c/span\x3e\x3cspan class\x3d"large secondary"\x3e\x3c/span\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_airspace hidden"\x3e\x3cdiv\x3e\x3cspan\x3eAirspace\x3c/span\x3e\x3cdiv class\x3d"decrement"\x3e\x3cimg alt\x3d"Reduce airspace ceiling" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAE0lEQVQImWP438DQAEP7kNj/GwCK4wo9HA2mvgAAAABJRU5ErkJggg\x3d\x3d" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3cdiv class\x3d"increment"\x3e\x3cimg alt\x3d"Increase airspace ceiling" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAGElEQVQImWP438DQ0MDQAUb7YAygyP8GAIyjCl0WJTcvAAAAAElFTkSuQmCC" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"large"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_thermals hidden"\x3e\x3cdiv\x3e\x3cspan\x3eThermals\x3c/span\x3e\x3cdiv class\x3d"decrement"\x3e\x3cimg src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAE0lEQVQImWP438DQAEP7kNj/GwCK4wo9HA2mvgAAAABJRU5ErkJggg\x3d\x3d" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3cdiv class\x3d"increment"\x3e\x3cimg src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJAQMAAADaX5RTAAAABlBMVEX///9xe4e/5menAAAAGElEQVQImWP438DQ0MDQAUb7YAygyP8GAIyjCl0WJTcvAAAAAElFTkSuQmCC" height\x3d"9" width\x3d"9"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"medium"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_close_flight"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Close flight') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_reset"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Reset') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_share"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Share') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_download"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Download') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_preferences"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Preferences') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_about"\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'About') + '\x3c/div\x3e\x3c/div\x3e\x3cdiv class\x3d"control_collapse"\x3e\x3cimg height\x3d"3" width\x3d"5" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADAQAAAABzTfhVAAAADklEQVQImWO4wdDBwAAABdYBYfESkFcAAAAASUVORK5CYII\x3d"\x3e\x3c/div\x3e\x3cdiv class\x3d"control_expand"\x3e\x3cimg height\x3d"3" width\x3d"5" src\x3d"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAUAAAADAQAAAABzTfhVAAAADklEQVQImWNgYOhguAEAAnYBYaFuVa4AAAAASUVORK5CYII\x3d"\x3e\x3c/div\x3e\x3c/div\x3e')
  }

  function ah()
  {
    return Tf('\x3cinput class\x3d"go_to_input" type\x3d"search"\x3e')
  }

  function bh(a)
  {
    for (var b = '\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'League') + '\x3c/div\x3e\x3cselect name\x3d"league" class\x3d"league_select"\x3e', c = a.pb, d = c.length, e = 0; e < d; e++) var f = c[e],
      b = b + ('\x3coption value\x3d"' + U(f.value) + '" ' + (f.selected ? ' selected\x3d"1"' : "") + "\x3e" + T(f.label) + "\x3c/option\x3e");
    b += '\x3c/select\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Distance units') + '\x3c/div\x3e\x3cselect name\x3d"distanceUnit" class\x3d"distanceUnit_select"\x3e';
    c = a.mb;
    d = c.length;
    for (e = 0; e < d; e++) f = c[e], b += '\x3coption value\x3d"' + U(f.value) +
      '" ' + (f.selected ? ' selected\x3d"1"' : "") + "\x3e" + T(f.label) + "\x3c/option\x3e";
    b += '\x3c/select\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Altitude units') + '\x3c/div\x3e\x3cselect name\x3d"altitudeUnit" class\x3d"altitudeUnit_select"\x3e';
    c = a.kb;
    d = c.length;
    for (e = 0; e < d; e++) f = c[e], b += '\x3coption value\x3d"' + U(f.value) + '" ' + (f.selected ? ' selected\x3d"1"' : "") + "\x3e" + T(f.label) + "\x3c/option\x3e";
    b += '\x3c/select\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Coordinates format') + '\x3c/div\x3e\x3cselect name\x3d"coordinateUnit" class\x3d"coordinateUnit_select"\x3e';
    a = a.lb;
    c = a.length;
    for (d = 0; d < c; d++) e = a[d], b += '\x3coption value\x3d"' + U(e.value) + '" ' + (e.selected ? ' selected\x3d"1"' : "") + "\x3e" + T(e.label) + "\x3c/option\x3e";
    return Tf(b + "\x3c/select\x3e\x3c/div\x3e")
  }

  function ch()
  {
    return Tf("\x3cdiv\x3e" + $pgettext('xc planner', 'Press Reset to reset your route permanently, press Cancel to keep you route.') + "\x3c/div\x3e")
  }

  function dh(a)
  {
    for (var b = "\x3cdiv\x3e\x3cdiv\x3e" + $pgettext('xc planner', 'Turnpoint details') + "\x3c/div\x3e\x3ctable\x3e", c = a.waypoints, d = c.length, e = 0; e < d; e++)
    {
      for (var f = c[e], b = b + ("\x3ctr\x3e\x3ctd\x3e" + T(f.id) + "\x3c/td\x3e"), h = f.coords, k = h.length, l = 0; l < k; l++)
        for (var n = h[l], m = n.length, r = 0; r < m; r++) var y = n[r],
          b = b + ('\x3ctd class\x3d"' + (0 == r ? "first_coordinate_element" : "coordinate_element") + '"\x3e' + T(y[0]) + T(y[1]) + "\x3c/td\x3e");
      b += '\x3ctd class\x3d"first_coordinate_element"\x3e' + T(f.elevation[0]) + T(f.elevation[1]) + "\x3c/td\x3e\x3c/tr\x3e"
    }
    b +=
      '\x3c/table\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Download') + '\x3c/div\x3e\x3cform action\x3d"https://xcplanner.appspot.com/geojson2file" target="_blank" class\x3d"download_form" method\x3d"post"\x3e\x3ctable\x3e\x3ctr\x3e\x3ctd\x3e\x3clabel for\x3d"format"\x3e' + $pgettext('xc planner', 'Format') + '\x3c/label\x3e\x3c/td\x3e\x3ctd\x3e\x3cselect name\x3d"format" class\x3d"downloadFormat_select"\x3e';
    c = a.nb;
    d = c.length;
    for (e = 0; e < d; e++) f = c[e], b += '\x3coption value\x3d"' + U(f.value) + '" ' + (f.selected ? ' selected\x3d"1"' : "") + "\x3e" + T(f.label) + "\x3c/option\x3e";
    b += '\x3c/select\x3e\x3c/td\x3e\x3c/tr\x3e\x3ctr\x3e\x3ctd\x3e\x3clabel for\x3d"routename"\x3e' + $pgettext('xc planner', 'Route name') + '\x3c/label\x3e\x3c/td\x3e\x3ctd\x3e\x3cinput name\x3d"routename" type\x3d"text" value\x3d"' +
      U(a.qb) + '"\x3e\x3c/td\x3e\x3c/tr\x3e\x3ctr\x3e\x3ctd\x3e\x3clabel for\x3d"waypointprefix"\x3e' + $pgettext('xc planner', 'Waypoint prefix') + '\x3c/label\x3e\x3c/td\x3e\x3ctd\x3e\x3cinput name\x3d"waypointprefix" type\x3d"text" value\x3d"' + U(a.rb) + '"\x3e\x3c/td\x3e\x3c/tr\x3e\x3c/table\x3e\x3cinput name\x3d"geojson" type\x3d"hidden" value\x3d"' + U(a.ob) + '"\x3e\x3c/form\x3e\x3c/div\x3e';
    return Tf(b)
  }

  function eh(a)
  {
    var b = Tf,
      c = '\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Lien') + '\x3c/div\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Paste link in email or IM') + '\x3cbr\x3e\x3cinput type\x3d"text" class\x3d"link_input" value\x3d"' + U(a.href) + '" style\x3d"width: 100%;"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3e' + $pgettext('xc planner', 'Static image') + '\x3c/div\x3e\x3cdiv\x3e\x3cinput type\x3d"text" class\x3d"link_input" value\x3d"' + U(a.lc) + '" style\x3d"width: 100%;"\x3e\x3c/div\x3e\x3c/div\x3e\x3cdiv\x3e\x3ca href\x3d"' + U(gg(a.nc)) + '"\x3e' + $pgettext('xc planner', 'Open with XCTrack') + '\x3c/a\x3e\x3c/div\x3e\x3cdiv\x3e\x3ca href\x3d"' +
      U(gg(a.Ab)) + '"\x3e' + $pgettext('xc planner', 'Share with LocToMe: set as default route') + '\x3c/a\x3e\x3c/div\x3e\x3cdiv\x3e\x3cdiv\x3eQR Code\x3c/div\x3e\x3cdiv\x3e\x3cimg src\x3d"https://xcplanner.appspot.com/qrcode?level\x3dL\x26text\x3d',
      d;
    d = encodeURIComponent(String(String(a.href)));
    eg.lastIndex = 0;
    d = eg.test(d) ? d.replace(eg, fg) : d;
    return b(c + d + '" width\x3d"' + U(a.width) + '" height\x3d"' + U(a.height) + '"/\x3e\x3c/div\x3e\x3c/div\x3e')
  };
  var fh = "formatgeo compegps gpx kml lk8000 oziexplorer seeyou xcsoar".split(" "),
    gh = "FormatGEO (GpsDump);CompeGPS;GPX;KML (Google Earth);LK8000;OziExplorer;SeeYou;XCSoar".split(";"),
    hh = ["#ff6600", "#ff9933", "#ffcc00", "#ffff00"],
    ih = {
      key: "close",
      caption: $pgettext('general', 'Close')
    },
    jh = {
      key: "download",
      caption: $pgettext('general', 'Download')
    },
    kh = {
      key: "go_to",
      caption: $pgettext('general', 'Go to')
    },
    lh = {
      key: "reset",
      caption: $pgettext('general', 'Reset')
    };

  function mh(a, b)
  {
    google.maps.event.addListenerOnce(a, 'idle', function () { mapReady(a) });
    google.maps.MVCObject.call(this);
    this.setValues(
    {
      airspace: b.sb || 0,
      altitudeUnit: b.xa || Db,
      coordinateUnit: b.Ya || Gb,
      distance: 0,
      distanceUnit: b.Za || Bb,
      constraint: b.Xa || new Ob(null, 2E4 / 3600),
      downloadFormat: b.tc || "formatgeo",
      geodesic: !0,
      flownDistance: 0,
      league: b.l || lc,
      multiplier: 1,
      points: 0,
      speedUnit: b.kc || Cb
    });
    this.set("map", a);
    var c = new V(
    {
      buffer: 50,
      fillOpacity: .2,
      strokeOpacity: .5,
      tableId: "2923451"
    });
    c.bindTo("airspace", this);
    c.bindTo("map", this);
    var c = De($g),
      d = new X(c);
    d.bindTo("airspace",
      this);
    d.bindTo("altitudeUnit", this);
    d.bindTo("constraint", this);
    d.bindTo("distance", this);
    d.bindTo("distanceUnit", this);
    d.bindTo("flownDistance", this);
    d.bindTo("name", this);
    d.bindTo("thermalLayer", this);
    d.bindTo("multiplier", this);
    d.bindTo("points", this);
    d.bindTo("speedUnit", this);
    L(K("control_about", c), "click", this.Bb, !1, this);
    L(K("control_close_flight", c), "click", this.Fb, !1, this);
    L(K("control_preferences", c), "click", this.Xb, !1, this);
    L(K("control_reset", c), "click", this.Yb, !1, this);
    L(K("control_share",
      c), "click", this.ac, !1, this);
    L(K("control_download", c), "click", this.Ib, !1, this);
    a.controls[google.maps.ControlPosition.RIGHT_TOP].push(c);
    this.h = new Wg(
    { // triangles
      fillColor1: "#ff0000",
      fillColor2: "#00ff00",
      fillColor3: "#0000ff",
      fillOpacity: .25,
      strokeColor1: "#ffffff",
      strokeColor2: "#ffffff",
      strokeColor3: "#ffffff",
      strokeOpacity: .5,
      strokeWeight: 2,
      zIndex: 1
    });
    this.B = this.H = null;
    this.F = b.Sa || null;
    this.M = this.c = this.L = this.a = null;
    this.b = new Fg(
    {
      clickable: !0,
      editable: !0,
      fillColor: "#000000",
      fillOpacity: 0,
      strokeColor: "#ff0000",
      strokeOpacity: 1,
      strokeWeight: 2,
      zIndex: 5
    });
    this.b.bindTo("geodesic", this);
    this.b.bindTo("map", this);
    google.maps.event.addListener(this.b.c, "dblclick", u(function()
    {
      this.get("map").fitBounds(Dg(this))
    }, this.b));
    this.j = new google.maps.Polyline(
    {
      clickable: !0,
      path: new google.maps.MVCArray,
      strokeColor: hh[0],
      strokeOpacity: 1,
      strokeWeight: 3,
      zIndex: 3
    });
    this.j.bindTo("geodesic", this);
    this.j.bindTo("map", this);
    google.maps.event.addListener(this.j, "dblclick",
      u(function()
      {
        var a = new google.maps.LatLngBounds;
        x(this.getPath().getArray(), a.extend, a);
        this.getMap().fitBounds(a)
      }, this.j));
    this.g = new Y(
    { // petit triangle
      fillColor: "#ffff00",
      fillOpacity: .1,
      strokeColor: "#ffffff",
      strokeOpacity: .5,
      strokeWeight: 2,
      zIndex: 2
    });
    this.X = 0;
    this.b instanceof Fg && google.maps.event.addListener(a, "rightclick", u(this.Zb, this));
    this.o = this.m = null;
    this.O = [];
    0 == b.path.length ? nh(this, a, b.center) : (this.b.setPath(new google.maps.MVCArray(b.path)), oh(this), this.v());
    this.K = [240, 1, .5];
    c = new ve(a.getDiv());
    L(c, "drop", this.Jb, !1, this)
  }
  w(mh, google.maps.MVCObject);

  function ph(a)
  {
    return a.get("map")
  }
  mh.prototype.Y = function()
  {
    this.v()
  };
  mh.prototype.league_changed = mh.prototype.Y;
  g = mh.prototype;
  g.Bb = function()
  {
    var a = new Q;
    Ae(a.U(), Zg);
    a.setTitle($pgettext('xc planner', 'About'));
    If(a, R(new S, zf, !0, !0));
    a.I(!0)
  };
  g.Fb = function()
  {
    var a = this.b.getPath(),
      b = a.getLength(),
      c = this.b.getPosition(a, 0),
      a = this.b.getPosition(a, b - 1);
    2 < b && 1E3 > google.maps.geometry.spherical.computeDistanceBetween(c, a) ? this.b.setAt(b - 1, new google.maps.LatLng(c.lat(), c.lng())) : zg(this.b, new google.maps.LatLng(c.lat(), c.lng()))
  };
  g.Rb = function()
  {
    var a = ph(this).getCenter(),
      b, c = this.b.getPath().getLength();
    for (b = 0; b < c; ++b) this.b.setAt(b, google.maps.geometry.spherical.computeOffset(a, 1E4, 270 + 360 * b / c, 6371E3))
  };
  g.Sb = function(a)
  {
    var b = Qf(a.target.result);
    a = new google.maps.LatLngBounds;
    x(b, a.extend, a);
    ph(this).fitBounds(a);
    b = new google.maps.Polyline(
    {
      path: b,
      strokeColor: Kc(this.K),
      strokeOpacity: 1,
      strokeWeight: 1,
      zIndex: 0
    });
    this.K[0] = (this.K[0] + 15) % 360;
    b.bindTo("geodesic", this);
    b.bindTo("map", this);
    google.maps.event.addListener(b, "dblclick", u(function()
    {
      this.unbind("map");
      this.setMap(null)
    }, b));
    google.maps.event.addListener(b, "rightclick", u(function(a)
    {
      this.getMap().fitBounds(a)
    }, b, a))
  };
  g.Jb = function(a)
  {
    a = a.c.dataTransfer.files;
    var b = u(this.Sb, this),
      c, d = a.length,
      e;
    for (c = 0; c < d; ++c) /\.igc$/i.test(a[c].name) && (e = new FileReader, e.onloadend = b, e.readAsText(a[c]))
  };
  g.Xb = function()
  {
    var a = this.get("altitudeUnit"),
      b = z(Ib, function(b, c)
      {
        return {
          label: Jb[c],
          selected: b === a,
          value: c
        }
      }),
      c = this.get("coordinateUnit"),
      d = z(Kb, function(a, b)
      {
        return {
          label: Lb[b],
          selected: a === c,
          value: b
        }
      }),
      e = this.get("distanceUnit"),
      f = z(Mb, function(a, b)
      {
        return {
          label: Nb[b],
          selected: a === e,
          value: b
        }
      }),
      h = this.get("league"),
      k = z(Hc, function(a, b)
      {
        return {
          label: a.W(),
          selected: a === h,
          value: b
        }
      }, this),
      l = new Q,
      n = l.U();
    Ae(n, bh,
    {
      kb: b,
      lb: d,
      mb: f,
      pb: k
    });
    L(K("altitudeUnit_select", n), "change", function(a)
    {
      var b = Ib[a.a.value];
      qb(sb, "altitudeUnit", a.a.value);
      b !== this.get("altitudeUnit") && this.set("altitudeUnit", b)
    }, !1, this);
    L(K("coordinateUnit_select", n), "change", function(a)
    {
      var b = Kb[a.a.value];
      qb(sb, "coordinateUnit", a.a.value);
      b !== this.get("coordinateUnit") && this.set("coordinateUnit", b)
    }, !1, this);
    L(K("distanceUnit_select", n), "change", function(a)
      {
        var b = Mb[a.a.value];
        qb(sb, "distanceUnit", a.a.value);
        b !== this.get("distanceUnit") && this.set("distanceUnit", b);
        a = b === Eb ? Fb : Cb;
        a != this.get("speedUnit") && this.set("speedUnit", a)
      },
      !1, this);
    L(K("league_select", n), "change", function(a)
    {
      a = Hc[a.a.value];
      a !== this.get("league") && this.set("league", a)
    }, !1, this);
    l.setTitle($pgettext('xc planner', 'Preferences'));
    b = new S;
    R(b, ih, !0, !0);
    If(l, b);
    l.I(!0)
  };
  g.Yb = function()
  {
    var a = new Q;
    Ae(a.U(), ch);
    a.setTitle("Reset");
    var b = new S;
    R(b, lh, !0, !1);
    R(b, Af, !1, !0);
    If(a, b);
    L(a, Jf, function(a)
    {
      a.key == lh.key && (a = ph(this), nh(this, a, a.getCenter()))
    }, !1, this);
    a.I(!0)
  };

  function oh(a)
  {
    x(a.O, function(a)
    {
      google.maps.event.removeListener(a)
    });
    var b = a.b.getPath(),
      c = u(a.v, a);
    a.O = z(["insert_at", "remove_at", "set_at"], function(a)
    {
      return google.maps.event.addListener(b, a, c)
    })
  }
  g.Zb = function(a)
  {
    zg(this.b, a.latLng)
  };
  g.ac = function()
  {
    var a = google.maps.geometry.encoding.encodePath(this.b.getPath()),
      b, c = new B('https://xcplanner.appspot.com/');
    b = new bb;
    var d = this.get("league");
    D(b, "l", d.getId());
    D(b, "p", a);
    d = this.get("constraint");
    null === d.a || D(b, "d", Math.round(d.a / 60));
    null === d.b || D(b, "s", (3600 * d.b / 1E3).toFixed(1));
    D(b, "a", this.get("airspace"));
    $a(c, b);
    var d = new B("http://maps.googleapis.com/maps/api/staticmap"),
      e = new bb;
    D(e, "size", "640x480");
    D(e, "maptype", "terrain");
    D(e, "key", "AIzaSyAeL75QTVdyogmANb1M0UKxcrE7LiCPqm0");
    D(e, "path", "color:0xff0000ff|weight:3|enc:" + a);
    $a(d, e);
    a = new B("http://loctome.com/lab/xcplanner/");
    $a(a, b);
    b = $f("tobis-paragliding-map:xcplanner.appspot.com/" + b.toString());
    var e = new B("http://xctrack.org/xcplanner"),
      f = new bb,
      h = [];
    this.b.getPath().forEach(function(a)
    {
      h.push(a.lat().toFixed(6) + "," + a.lng().toFixed(6))
    });
    D(f, "route", h.join(":"));
    $a(e, f);
    f = new Q;
    Ae(f.U(), eh,
    {
      height: 256,
      href: c.toString(),
      Ab: a.toString(),
      gc: b,
      lc: d.toString(),
      width: 256,
      nc: e.toString()
    });
    f.setTitle($pgettext('xc planner', 'Share'));
    c = new S;
    R(c, ih, !0, !0);
    If(f, c);
    L(f, "show", function(a)
    {
      a = K("link_input", a.a.U());
      a.focus();
      a.select()
    });
    f.I(!0)
  };
  g.Ib = function()
  {
    null === this.B && (this.B = new google.maps.ElevationService);
    this.B.getElevationForLocations(
    {
      locations: this.c
    }, u(function(a, b)
    {
      var c = this.get("altitudeUnit"),
        d = this.get("coordinateUnit"),
        e = this.get("downloadFormat"),
        f = z(fh, function(a, b)
        {
          return {
            label: gh[b],
            selected: a == e,
            value: a
          }
        }),
        h = z(this.c, function(e, f)
        {
          return {
            id: ua(f + 1, 3),
            coords: [d(e.lat(), "NS"), d(e.lng(), "EW")],
            elevation: b == google.maps.ElevationStatus.OK ? c(a[f].elevation) : [0, 0]
          }
        }, this),
        k = {
          features: z(this.c, function(c, d)
          {
            var e = "T" +
              ua(d + 1, 2),
              f = [c.lng(), c.lat()];
            b == google.maps.ElevationStatus.OK ? (f.push(a[d].elevation), e += ua(a[d].elevation / 10, 3, 0)) : e += "000";
            return {
              geometry:
              {
                coordinates: f,
                type: "Point"
              },
              properties:
              {
                id: e
              },
              type: "Feature"
            }
          }, this),
          type: "FeatureCollection"
        },
        l = new Q;
      Ae(l.U(), dh,
      {
        nb: f,
        ob: we(k),
        qb: "XC Planner route",
        waypoints: h,
        rb: "XCP"
      });
      l.setTitle($pgettext('xc planner', 'Download'));
      f = new S;
      R(f, ih, !0, !0);
      R(f, jh, !1, !1);
      If(l, f);
      L(l, Jf, function(a)
      {
        var b = a.a;
        a.key == jh.key && (K("download_form", b.U()).submit(), b.I(!1))
      });
      l.I(!0)
    }, this))
  };
  g.Qb = function()
  {
    var a = new Q;
    Ae(a.U(), ah,
    {});
    a.setTitle("Go to");
    var b = K("go_to_input", a.U());
    new google.maps.places.Autocomplete(b,
    {
      bounds: ph(this).getBounds(),
      types: ["geocode"]
    });
    var c = new S;
    R(c, kh, !0, !1);
    R(c, Af, !1, !0);
    If(a, c);
    L(a, "show", function()
    {
      b.focus()
    });
    L(a, Jf, function(a)
      {
        a.key == kh.key && (null === this.F && (this.F = new google.maps.Geocoder), this.F.geocode(
        {
          address: Lc(b),
          bounds: ph(this).getBounds()
        }, u(function(a, b)
        {
          b == google.maps.GeocoderStatus.OK && ph(this).fitBounds(a[0].geometry.viewport)
        }, this)))
      },
      !1, this);
    a.I(!0)
  };
  g.Ob = function()
  {
    google.maps.event.removeListener(this.m);
    this.m = null;
    google.maps.event.removeListener(this.o);
    this.o = null
  };

  function nh(a, b, c)
  {
    var d = new google.maps.MVCArray,
      e;
    for (e = 0; 2 > e; ++e) d.push(google.maps.geometry.spherical.computeOffset(c, 1E4, 270 + 360 * e / 2, 6371E3));
    Cg(a.b, !1);
    a.b.setPath(d);
    oh(a);
    a.v();
    null === a.m && (a.m = google.maps.event.addListener(a.b, "first_modified", u(a.Ob, a)));
    null === a.o && (a.o = google.maps.event.addListener(b, "idle", u(a.Rb, a)))
  }
  g.mc = function()
  {
    var a = ph(this),
      b = this.get("thermalLayer");
    null === b ? a.overlayMapTypes.removeAt(0) : a.overlayMapTypes.setAt(0, b)
  };
  mh.prototype.thermalLayer_changed = mh.prototype.mc;
  mh.prototype.v = function()
  {
    var a = this.get("league");
    if (q(a) && q(this.b))
    {
      this.c = this.b.getPath().getArray();
      this.M = new Pb(this.c);
      var b = a.P(this.c, this.M);
      Ha(b, function(a, b)
      {
        return b.a - a.a
      });
      this.a = b[0];
      this.L = a.oa(this.a.J.length);
      for (var a = 0, c = this.c.length, b = 1; b < c; ++b) a += Qb(this.M, b - 1, b);
      this.a.distance != this.get("distance") && this.set("distance", this.a.distance);
      a != this.get("flownDistance") && this.set("flownDistance", a);
      this.a.$ != this.get("multiplier") && this.set("multiplier", this.a.$);
      this.a.name !=
        this.get("name") && this.set("name", this.a.name);
      this.a.a != this.get("points") && this.set("points", this.a.a);
      qh(this);
      rh(this);
      sh(this);
      th(this)
    }
  };

  function qh(a)
  {
    var b = a.j.getPath(),
      c = a.a.J.length,
      d = b.getLength(),
      e = Math.min(c, d),
      f, h;
    for (f = 0; f < e; ++f) h = b.getAt(f), a.c[a.a.J[f]].equals(h) || b.setAt(f, a.c[a.a.J[f]]);
    for (f = e; f < c; ++f) b.push(a.c[a.a.J[f]]);
    for (f = d - 1; f >= c; --f) b.removeAt(f);
    a.X != a.a.ja && (a.j.set("strokeColor", hh[a.a.ja]), a.X = a.a.ja)
  }

  function rh(a)
  {
    var b, c;
    if (a.a.ua)
      for (b = Array(3), c = 0; 3 > c; ++c) b[c] = a.c[a.a.ua[c]];
    else b = null;
    if (null === b) null !== a.H && (a.h.unbind("map"), a.h.set("map", null));
    else
    {
      ++a.h.b;
      for (c = 0; 3 > c; ++c) a.h.setAt(c, b[c]);
      c = a.h;
      0 === --c.b && c.c && Xg(c);
      null === a.H && a.h.bindTo("map", a)
    }
    a.H = b
  }

  function sh(a)
  {
    var b = Ja(a.b.getPath().getLength());
    x(a.a.J, function(a, d)
    {
      b[a] = "" === b[a] ? this.L[d] : b[a] + (", " + this.L[d])
    }, a);
    Eg(a.b, b)
  }

  function th(a)
  {
    if (null != a.a.ia)
    {
      var b = a.g.getCenter(),
        c = a.c[a.a.J[0]];
      q(b) && b.equals(c) || a.g.set("center", c);
      var d = a.c[a.a.J[a.a.J.length - 1]],
        b = a.g.get("heading") || 0,
        c = google.maps.geometry.spherical.computeHeading(c, d);
      q(b) && b == c || a.g.set("heading", c);
      (a.g.get("radius") || 0) != a.a.ia && a.g.set("radius", a.a.ia);
      null != a.g.get("map") || a.g.bindTo("map", a)
    }
    else null !== a.g.get("map") && (a.g.unbind("map"), a.g.set("map", null))
  };
  var Ma = {
      AR:
      {
        l: F
      },
      AT:
      {
        l: lc
      },
      AU:
      {
        l: bc
      },
      BR:
      {
        l: F
      },
      CA:
      {
        xa: Ab,
        l: cc
      },
      CH:
      {
        l: dc
      },
      CL:
      {
        l: ec
      },
      CU:
      {
        l: F
      },
      CZ:
      {
        l: fc
      },
      DE:
      {
        l: F
      },
      DK:
      {
        l: F
      },
      ES:
      {
        l: gc
      },
      FI:
      {
        l: hc
      },
      FR:
      {
        l: nc
      },
      GB:
      {
        xa: Ab,
        Ya: Hb,
        l: Gc
      },
      GR:
      {
        l: F
      },
      HU:
      {
        l: ic
      },
      IE:
      {
        l: F
      },
      IT:
      {
        l: lc
      },
      LT:
      {
        l: jc
      },
      LU:
      {
        l: F
      },
      LV:
      {
        l: lc
      },
      MX:
      {
        l: sc
      },
      NL:
      {
        l: lc
      },
      PL:
      {
        l: wc
      },
      PT:
      {
        l: F
      },
      RO:
      {
        l: lc
      },
      RU:
      {
        l: F
      },
      SK:
      {
        l: kc
      },
      TR:
      {
        l: F
      },
      US:
      {
        xa: Ab,
        Za: Eb,
        kc: Fb
      }
    },
    uh = {
      cfd: nc,
      olc: F,
      ukxcl: Gc,
      xc: lc
    },
    vh = /^\[((?:\[\-?\d+(?:\.\d*)?,\-?\d+(?:\.\d*)?\])(?:,\[\-?\d+(?:\.\d*)?,\-?\d+(?:\.\d*)?\])+)\]$/,
    wh = /^\[(\-?\d+(?:\.\d*)?),(\-?\d+(?:\.\d*)?)\]/,
    xh = /^(cfd|olc|ukxcl|xc)(\d+)(c?)$/;

  function yh(a)
  {
    var b, c, d = a.address_components.length;
    for (c = 0; c < d; ++c)
      if (b = a.address_components[c], Ba(b.types, "country")) return b.short_name;
    return null
  }

  function zh(a, b)
  {
    var c = new google.maps.Map(a,
    {
      // draggable: false,
      // scrollwheel: false,
      // panControl: false,
      scaleControl: !1,
      streetViewControl: !1,
      mapTypeControl: !1,
      fullscreenControl: !1,
      zoomControl: !1,
      mapTypeControlOptions:
      {
        mapTypeIds: ["empty", "xcontest"]
      },
      mapTypeId: "empty",
      backgroundColor: 'none'
    });
    c.mapTypes.set("xcontest", new google.maps.ImageMapType(wb));
    c.mapTypes.set("empty", new EmptyMap());
    if (0 == b.path.length) b.bounds ? (c.fitBounds(b.bounds), b.center = b.bounds.getCenter()) : (b.center = b.center || new google.maps.LatLng(46, 11), c.setCenter(b.center),
      c.setZoom(b.zoom || 7));
    else
    {
      var d = new google.maps.LatLngBounds;
      x(b.path, function(a)
      {
        d.extend(a)
      });
      c.fitBounds(d);
      b.center = d.getCenter()
    }
    La(b.country) && Ka(Ma[b.country], function(a, c)
    {
      A(b, c, a)
    });
    if (q(rb("altitudeUnit")))
    {
      var e = parseInt(rb("altitudeUnit"), 10);
      isNaN(e) || (b.xa = Ib[e])
    }
    q(rb("distanceUnit")) && (e = parseInt(rb("distanceUnit"), 10), isNaN(e) || (b.Za = Mb[e]));
    q(rb("coordinateUnit")) && (e = parseInt(rb("coordinateUnit"), 10), isNaN(e) || (b.Ya = Kb[e]));
    new mh(c, b)
  }

  function Ah()
  {
    var a = Bh,
      b = Ch;
    b.Sa.geocode(
    {
      address: b.address
    }, function(c, d)
    {
      d == google.maps.GeocoderStatus.OK && (b.bounds = c[0].geometry.bounds, b.center = c[0].geometry.location, b.country = yh(c[0]));
      zh(a, b)
    })
  }

  function Dh()
  {
    var a = Bh,
      b = Ch;
    navigator.geolocation ? navigator.geolocation.getCurrentPosition(function(c)
    {
      b.center = new google.maps.LatLng(c.coords.latitude, c.coords.longitude);
      b.zoom = b.zoom || 10;
      /* b.Sa.geocode(
      {
        location: b.center
      }, function(c, e)
      {
        e == google.maps.GeocoderStatus.OK && (b.country = yh(c[0]));
        zh(a, b)
      }) */
      zh(a, b)
    }, function()
    {
      zh(a, b)
    }) : zh(a, b)
  }


  var Bh;
  Bh = t("map") ? document.getElementById("xc-map") : "map";
  // top.location != self.location && (top.location = self.location.href);
  var Ch = {
    center: null
  };
  Ch.Sa = new google.maps.Geocoder;
  Ch.path = [];
  Ch.zoom = null;
  var Eh;
  Eh = (new B('https://xcplanner.appspot.com/')).b;
  var Fh = Ch,
    Gh, Z, Hh;
  C(Eh, "location") && (Fh.address = nb(Eh, "location"));
  C(Eh, "start") && (Z = wh.exec(nb(Eh, "start")), null === Z || Fh.path.push(new google.maps.LatLng(parseFloat(Z[1]), parseFloat(Z[2]))));
  if (C(Eh, "turnpoints") && (Z = vh.exec(nb(Eh, "turnpoints")), null !== Z))
    for (Hh = Z[1], Z = wh.exec(Hh), Fh.path.push(new google.maps.LatLng(parseFloat(Z[1]), parseFloat(Z[2]))), Hh = Hh.slice(Z[0].length + 1); !/^[\s\xa0]*$/.test(Hh);) Z = wh.exec(Hh), Fh.path.push(new google.maps.LatLng(parseFloat(Z[1]), parseFloat(Z[2]))), Hh = Hh.slice(Z[0].length + 1);
  C(Eh, "flightType") && (Z = xh.exec(nb(Eh, "flightType")), null !== Z && (Fh.l = uh[Z[1]], (Gh = "c" == Z[3]) && 0 != Fh.path.length && Fh.path.push(Fh.path[0])));
  (function(a, b)
  {
    C(b, "a") && (a.sb = parseInt(nb(b, "a"), 10));
    C(b, "c") && (a.address = nb(b, "c"));
    C(b, "d") && (a.Xa = new Ob(60 * parseInt(nb(b, "d"), 10), null));
    if (C(b, "l"))
    {
      var c = nb(b, "l");
      x(Hc, function(b)
      {
        c == b.getId() && (a.l = b)
      })
    }
    C(b, "p") && (a.path = google.maps.geometry.encoding.decodePath(nb(b, "p")));
    C(b, "s") && (a.Xa = new Ob(null, 1E3 * parseInt(nb(b, "s"), 10) / 3600));
    C(b, "z") && (a.zoom = parseInt(nb(b, "z"), 10))
  })(Ch, Eh);
  0 == Ch.path.length ? Ch.address ? Ah() : Dh() : zh(Bh, Ch);
}



// WEBPACK FOOTER //
// ./src/assets/xcplanner.js